// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:33:07.551Z
// Property: The Crest (ID: 6767906449167040)
// Collections: 23 amenities, 7 floorplans (live), 42 photos, 60 POIs, 4 reviews, 1 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167040",
  "property_external_id": "48312",
  "property_zillow_url": "https://www.zillow.com/apartments/el-paso-tx/the-crest/5XrGT6/",
  "property_apartments_url": "https://www.apartments.com/the-crest-el-paso-tx/3ww1gbf/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Crest+Apartments/data=!4m2!3m1!1s0x0:0x568384987e98bcfd?sa=X&ved=2ahUKEwj2jZm3hIOTAxWtD0QIHd3kCCkQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "34370075733",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-crest",
  "property_name": "The Crest",
  "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/the-crest/",
  "property_domain": null,
  "property_address": "345 Shadow Mountain Dr.",
  "property_full_address": "345 Shadow Mountain Dr., El Paso, TX, 79912",
  "property_address_1": "345 Shadow Mountain Dr.",
  "property_address_2": null,
  "property_address_city": "El Paso",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79912",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Northwest El Paso",
  "property_address_latitude": "31.8356",
  "property_address_longitude": "-106.5271",
  "property_email": "thecrest@caseusa.com",
  "property_phone": "(915) 284-8917",
  "property_call_tracking_phone": "844-930-4651",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to The Crest in El Paso, where modern living meets comfort. Choose from thoughtfully designed one, two, or three-bedroom floor plans, complete with upgraded stainless-steel appliances and spacious closets. Enjoy amenities like a refreshing pool, BBQ area, and pet park. Your perfect home awaits—explore our availability today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to The Crest, your ideal apartment community nestled in the heart of El Paso, TX! Offering an array of thoughtfully designed floor plans, including one, two, and three-bedroom options, The Crest is perfect for individuals, couples, and families alike. Each apartment is enhanced with upgraded stainless-steel kitchen appliances, wood-plank flooring, and spacious closets, while some units feature charming wood-burning fireplaces and convenient W/D hookups.\n\nOur pet-friendly community boasts exceptional amenities that cater to your lifestyle. Enjoy sunny afternoons at our BBQ/picnic area, unwind by our beautiful pool, or engage in friendly competition at the basketball court. Need to balance work and play? Our business center and fitness center are at your service, ensuring you have everything you need right at home. For pet owners, we offer an onsite pet park to let your furry friends roam!\n\nAt The Crest, we understand the importance of flexibility, which is why we provide multiple payment options, electronic payments, and short-term leases. Plus, our Spanish-speaking staff is available to assist you. Located close to public transportation, you'll have easy access to all that El Paso has to offer.\n\nWhether you're seeking a roommate-friendly floorplan or a cozy private balcony to relax on, The Crest has the perfect space for you. Don’t wait — find your new home today! Browse our availability or schedule a tour to visit our vibrant community. Experience the comfort and convenience of living at The Crest!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb53-296d-75cf-85fa-8510acb94549.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of an apartment complex with a pool and surrounding residential areas.",
    "public_id": "019cfb53-296d-75cf-85fa-8510acb94549",
    "storage_key": "property/6767906449167040/019cfb53-296d-75cf-85fa-8510acb94549.webp",
    "width": 2700,
    "height": 1799
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "232",
  "property_year_built": "1992",
  "property_year_renovated": null,
  "property_walk_score": "63",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.84482758620689",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "We welcome cats and dogs up to 80 lb each. Maximum 2 pets per unit.",
  "property_pet_policy_description": "Above applies to pets 1-80 pounds",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://crestapartmentselpaso.securecafe.com/onlineleasing/the-crest/floorplans.aspx",
  "property_resident_portal_url": "https://crestapartmentselpaso.securecafe.com/residentservices/the-crest/userlogin.aspx",
  "property_apply_now_url": "https://crestapartmentselpaso.securecafe.com/onlineleasing/the-crest/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-9592-76a4-8f50-ebe6498939dd.webp",
  "property_primary_logo_media": {
    "alt_text": "The Crest Apartments logo",
    "public_id": "019cfb51-9592-76a4-8f50-ebe6498939dd",
    "storage_key": "property/6767906449167040/019cfb51-9592-76a4-8f50-ebe6498939dd.webp",
    "width": 300,
    "height": 210
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb53-378d-704b-a580-f0e5619059d0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Crest Apartments logo",
    "public_id": "019cfb53-378d-704b-a580-f0e5619059d0",
    "storage_key": "property/6767906449167040/019cfb53-378d-704b-a580-f0e5619059d0.webp",
    "width": 300,
    "height": 210
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb53-47b9-77c8-9197-f419d29d5697.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Crest Apartments logo",
    "public_id": "019cfb53-47b9-77c8-9197-f419d29d5697",
    "storage_key": "property/6767906449167040/019cfb53-47b9-77c8-9197-f419d29d5697.webp",
    "width": 300,
    "height": 210
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#d4af37",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "947 - 1036",
  "property_sqft_min": "947",
  "property_sqft_max": "1036",
  "property_price_range": "1480 - 1673",
  "property_price_min": "1480",
  "property_price_max": "1673",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/thecrestapartment/photos/",
  "property_instagram_url": "https://www.instagram.com/the_crest_apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJRSekvttX54YR_byYfpiEg1Y",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartment&find_loc=El+Paso%2C+TX",
  "property_tiktok_url": "https://www.tiktok.com/@thecrestapartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Crest",
  "property_home_romance_title": "Embrace the Life You’ve Always Dreamed Of Here",
  "property_home_amenities_blurb": "Welcome to The Crest, a vibrant El Paso community where comfort meets convenience. Choose from one, two, or three-bedroom floor plans that cater to your lifestyle. Enjoy relaxing by the beautiful pool or hosting a BBQ in our pet-friendly picnic area, all while benefiting from upgraded amenities that elevate your living experience.",
  "property_home_floorplans_blurb": "Welcome to The Crest in sunny El Paso, TX—where style meets comfort. Our diverse floor plans cater to every lifestyle, featuring modern designs and spacious layouts. Unwind in your ideal apartment haven. Browse our available homes today and envision the perfect backdrop for your life at The Crest!",
  "property_home_gallery_blurb": "Welcome to The Crest in El Paso, TX, where comfort and convenience meet. Choose from our thoughtfully designed one, two, and three-bedroom floor plans, complete with upgraded stainless-steel appliances and spacious closets. Enjoy amenities like a sparkling pool, fitness center, and pet-friendly onsite park. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At The Crest in El Paso, TX, enjoy spacious one, two, and three-bedroom apartments nestled near exciting attractions. Unwind at Franklin Mountains State Park, visit the University of Texas at El Paso, or embrace adventure at Urban Air Trampoline Park. See what's around our community and find your next favorite spot!",
  "property_home_reviews_blurb": "At The Crest in El Paso, TX, residents rave about the vibrant community spirit and stunning amenities. One resident shares, “Living here feels like being part of a family.” Experience comfort and connection in a place you’ll love to call home. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of El Paso, The Crest offers a vibrant lifestyle just steps from the action. With easy access to Fort Bliss and cultural gems like the La Nube STEAM Discovery Center, you’ll never run out of adventures. See what surrounds our community and uncover local favorites today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Crest in El Paso, TX, elevate your lifestyle with our thoughtfully designed one, two, and three-bedroom apartments. Enjoy a vibrant BBQ area, a refreshing pool, and a pet park right at your doorstep. With modern amenities and flexible lease options, this is your ideal community for comfort and convenience.",
  "property_applynow_blurb": "At The Crest in El Paso, TX, we offer spacious one, two, and three-bedroom apartments designed for every lifestyle. Enjoy premium amenities like upgraded stainless-steel appliances, a beautiful pool, and pet-friendly options, all just steps from public transport. Find your new home and lease online today!",
  "property_contactus_blurb": "At The Crest in El Paso, TX, we cater to every lifestyle with thoughtfully designed floor plans, including one, two, and three-bedroom options. Whether you're seeking cozy comfort or spacious living, we have the perfect home for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At The Crest in El Paso, TX, we offer a variety of floor plans—one, two, and three bedrooms—to perfectly suit your lifestyle. Curious about our community? Visit our FAQs page for insightful answers and learn what makes life at The Crest so exceptional!",
  "property_floorplans_blurb": "At The Crest in El Paso, TX, your dream apartment awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Each home combines comfort and style, ensuring a perfect fit for everyone. Browse our available apartment homes and find the ideal space just for you!",
  "property_gallery_blurb": "At The Crest in El Paso, TX, your dream home awaits! Choose from spacious one, two, or three-bedroom floor plans featuring modern amenities like upgraded stainless-steel kitchens and cozy wood-burning fireplaces. Picture yourself unwinding by the beautiful pool or enjoying a barbecue at the onsite picnic area! ",
  "property_interactivemap_blurb": "At The Crest in El Paso, TX, find your perfect sanctuary with a variety of floor plans including spacious one, two, and three-bedroom options. Enjoy premium amenities like a beautiful pool, onsite pet park, and fitness center, all designed for your comfort. Use our interactive community map to select your new home!",
  "property_pets_blurb": "At The Crest in El Paso, TX, your furry companions are cherished as family. Bring along your cats and dogs—up to 80 lbs each—while enjoying spacious living and vibrant community amenities. With a welcoming pet policy, indulge in a lifestyle where paws and hearts connect in harmony.",
  "property_referafriend_blurb": "At The Crest in El Paso, TX, we celebrate the power of community! Choose from our stylish one, two, and three-bedroom floor plans designed for comfort and convenience. Great friends make great neighbors—refer a friend to join you in this vibrant home today and enjoy living life together!",
  "property_residentaccess_blurb": "Welcome to The Crest in El Paso, TX, where comfort meets convenience. Choose from our thoughtfully designed one, two, and three-bedroom floor plans. Take control of your living experience by accessing our resident portal—pay rent, schedule maintenance, and unlock a world of community features today!",
  "property_reviews_blurb": "At The Crest in El Paso, TX, residents rave about the “friendly atmosphere” and “spacious layouts” that make calling this community home a true delight. Dive into our resident reviews and see why The Crest is the perfect blend of comfort and convenience! Ready to be part of our community?",
  "property_created_at": "1770657256599",
  "property_scheduletour_blurb": "At The Crest in El Paso, TX, find your perfect home with spacious floor plans tailored for every lifestyle—choose from one, two, or three-bedroom layouts. Schedule a tour today and see what our residents love about calling The Crest their home sweet home. Your ideal living experience awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to The Crest in vibrant El Paso, TX! Our diverse floor plans—one, two, and three-bedroom apartments—are designed to suit every lifestyle. A team member will connect with you soon to help you find your perfect home. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "At The Crest in El Paso, TX, your ideal home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to every lifestyle. Dive into a virtual tour and envision your new beginning in a vibrant community that complements your unique living experience!",
  "property_copyright": "2026 All Rights Reserved. The Crest",
  "property_seo_title_home": "The Crest |  Apartments in El Paso, TX",
  "property_seo_description_home": "Experience elevated living at The Crest in El Paso! Enjoy spacious floor plans, modern amenities, and vibrant community spaces. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | El Paso, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Crest in El Paso! Choose from one, two, or three-bedroom floor plans that fit your lifestyle. Browse our available homes today!",
  "property_seo_title_amenities": "Amenities | El Paso, TX Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at The Crest in El Paso, TX! Enjoy spacious floor plans, a stunning pool, and pet-friendly amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in El Paso, TX",
  "property_seo_description_gallery": "Discover The Crest in El Paso, TX. Enjoy spacious floor plans, a beautiful pool, and an onsite pet park. Imagine your new lifestyle!",
  "property_seo_title_virtualtours": "Virtual Tours | The Crest Apartments",
  "property_seo_description_virtualtours": "Experience home at The Crest in El Paso, TX! Take a virtual tour and explore our stunning one, two, and three-bedroom apartments ready for you!",
  "property_seo_title_interactivemap": "Interactive Map | The Crest Apartments",
  "property_seo_description_interactivemap": "Find your perfect apartment at The Crest in El Paso, TX! Use our interactive map to explore stunning floor plans, top-notch amenities, & vibrant living.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in El Paso, TX",
  "property_seo_description_neighborhood": "Uncover the charm surrounding The Crest in El Paso, TX. From cozy cafes to scenic parks, dive into local gems just moments from your new home!",
  "property_seo_title_contact": "Contact Us | The Crest",
  "property_seo_description_contact": "Reach out to The Crest in El Paso, TX! Our leasing team is ready to help with your one, two, or three-bedroom apartment inquiries. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in El Paso, TX",
  "property_seo_description_faqs": "Find answers to your burning questions at The Crest! From pet policies to lease options, our FAQs page has you covered for life in El Paso, TX.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in El Paso, TX",
  "property_seo_description_reviews": "Experience life at The Crest in El Paso, TX! Our residents rave about our pet-friendly oasis, stylish amenities, and vibrant community. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in El Paso, TX",
  "property_seo_description_applynow": "Experience The Crest in El Paso, TX—your pet-friendly oasis with spacious floor plans, modern amenities, and a beautiful pool. Find your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | The Crest",
  "property_seo_description_residentaccess": "Elevate your living experience at The Crest! Log in to your resident portal for seamless rent payments, maintenance requests, and community updates in El Paso.",
  "property_seo_title_referafriend": "Refer A Friend | The Crest",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Crest in El Paso and enjoy vibrant living together in a community that feels like home.",
  "property_seo_title_scheduletour": "Schedule a Tour | The Crest",
  "property_seo_description_scheduletour": "Experience modern living at The Crest in El Paso, TX! Schedule a tour today and envision your new life surrounded by luxury and vibrant community amenities.",
  "property_seo_title_privacy": "Privacy Policy | The Crest",
  "property_seo_description_privacy": "At The Crest in El Paso, your peace of mind matters. Uncover how we safeguard your data. View our privacy policy for details on your privacy rights.",
  "property_seo_title_accessibility": "Website Accessibility | The Crest",
  "property_seo_description_accessibility": "At The Crest in El Paso, we prioritize digital inclusion with features for all, promoting accessible living in a welcoming community.",
  "property_seo_title_sitemap": "Sitemap | The Crest",
  "property_seo_description_sitemap": "Navigate through The Crest in El Paso, TX! Check our sitemap for a seamless experience finding your ideal apartment and community features.",
  "property_seo_title_thankyou": "Thank You | The Crest",
  "property_seo_description_thankyou": "Thank you for reaching out to The Crest in El Paso! Our team is excited to connect with you soon. Your future home awaits—stay tuned for updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in El Paso, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865937812",
  "amenities": [
    {
      "id": "ec_168deee8834ce8b016fdb0d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397273",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9deed521267b7ce0ab9a0d4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397274",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c531cd55ccd56aaf990049f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397275",
      "title": "Onsite Pet Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f64310276dec706cae7ec167",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397276",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bcd09ccf0b26b00088fa0af0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397277",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_409109d4139fd271e9b3f15a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397278",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1dcf2ee9ef79d8cd1466353",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397279",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bec1e089eee8e34b8139152d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397281",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56c9a4f8cbbbe462b16cf5a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397282",
      "title": "Short Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3acfddf234a89555cc130189",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397284",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_583c9f7e4c3621ab3b50c01c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397285",
      "title": "Beautiful Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_528b2b1accce74d056516341",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397286",
      "title": "Corporate Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8aa1ce8365bbd4bc657f0c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127397287",
      "title": "Two Onsite Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa021e39998f76084895b05c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127398743",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30935f63ba575f03fd57777c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127398744",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3dffeaf83ebb3e4264511b15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127398745",
      "title": "Reliable Cell Reception",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bda5e800d4cd0f861723fd74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127398746",
      "title": "Mirrored Closet Doors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c964356022a88a853b0d0d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127398747",
      "title": "W/D Hookup*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b88c7e36206363ff869e029b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127398748",
      "title": "Private Patio/Balcomy",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb935b3d2a560a9f4fb2d4fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127398749",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08b34518f43a41b7ccd7fa54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127398750",
      "title": "Refrigerated Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7b3c498919e83a9b4ba6722",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127398751",
      "title": "Roommate Friendly Floorplan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa0c036b17d21f0d7844abc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "yardi",
      "external_id": "127398752",
      "title": "Wood-Burning Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_5d4ff4dd-1161-447a-adc7-2fc4a225e432",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-b43e-74f3-8be6-cff207197c14.webp",
      "image_media": {
        "alt_text": "Exterior sign for The Crest Apartments with a red Case & Associates sign, landscaped with rocks.",
        "public_id": "019d20b9-b43e-74f3-8be6-cff207197c14",
        "storage_key": "property/6767906449167040/019d20b9-b43e-74f3-8be6-cff207197c14.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior entrance signs for The Crest Apartments featuring Case & Associates branding and desert landscaping.",
      "link": "",
      "alt_text": "Exterior sign for The Crest Apartments with a red Case & Associates sign, landscaped with rocks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp"
    },
    {
      "id": "custom_dd8fe22a-b7ff-4d9c-b026-78e17e9e8080",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-b44a-77ea-b196-49e405483683.webp",
      "image_media": {
        "alt_text": "Aerial view of a large apartment complex with multiple beige buildings, parking lots, and trees.",
        "public_id": "019d20b9-b44a-77ea-b196-49e405483683",
        "storage_key": "property/6767906449167040/019d20b9-b44a-77ea-b196-49e405483683.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Community",
      "description": "Aerial view of a multifamily community with townhouse-style buildings, a central pool, and ample parking.",
      "link": "",
      "alt_text": "Aerial view of a large apartment complex with multiple beige buildings, parking lots, and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-423e-71ac-8cc4-3e7bf4b7cda2.webp"
    },
    {
      "id": "custom_6ac789d8-f239-44dc-942f-58922f974cfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-b438-74be-9e34-e8185383427b.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick-and-white apartment complex with a parking lot and manicured shrubs.",
        "public_id": "019d20b9-b438-74be-9e34-e8185383427b",
        "storage_key": "property/6767906449167040/019d20b9-b438-74be-9e34-e8185383427b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with brick and white facades, shrub landscaping, and ample parking.",
      "link": "",
      "alt_text": "Exterior view of a brick-and-white apartment complex with a parking lot and manicured shrubs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3377-71d2-bca0-f31ed2acd4ab.webp"
    },
    {
      "id": "custom_9e397938-cdbe-4ea0-a87f-3847e16273d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-b438-74be-9e34-e636bae55c56.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with purple and green surface, fenced beside a brick building.",
        "public_id": "019d20b9-b438-74be-9e34-e636bae55c56",
        "storage_key": "property/6767906449167040/019d20b9-b438-74be-9e34-e636bae55c56.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor basketball court as part of the community amenities, featuring a colorful surface and surrounding fence.",
      "link": "",
      "alt_text": "Outdoor basketball court with purple and green surface, fenced beside a brick building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-33c1-72bd-9ba6-3f1c8caeb4b5.webp"
    },
    {
      "id": "custom_0252d356-06f7-461b-97fe-f2a1245b1b2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-be11-712b-b5b9-e6ed142c1fab.webp",
      "image_media": {
        "alt_text": "Outdoor seating area at an apartment building entrance with purple-framed glass doors and blue chairs.",
        "public_id": "019d20b9-be11-712b-b5b9-e6ed142c1fab",
        "storage_key": "property/6767906449167040/019d20b9-be11-712b-b5b9-e6ed142c1fab.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Communal outdoor seating by the apartment building entrance, featuring blue chairs and stone-pattern paving.",
      "link": "",
      "alt_text": "Outdoor seating area at an apartment building entrance with purple-framed glass doors and blue chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3345-74dc-abe5-b8d6cbb7e3bf.webp"
    },
    {
      "id": "custom_5001a589-f8ee-4014-8d39-5fdc1c1dc7a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-bedd-764f-945f-f85c8ddd24bc.webp",
      "image_media": {
        "alt_text": "Outdoor communal grilling area with two built-in stainless steel grills and a stone counter.",
        "public_id": "019d20b9-bedd-764f-945f-f85c8ddd24bc",
        "storage_key": "property/6767906449167040/019d20b9-bedd-764f-945f-f85c8ddd24bc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor community grilling area at the apartment complex with built-in grills, a stone counter, and surrounding landscaping.",
      "link": "",
      "alt_text": "Outdoor communal grilling area with two built-in stainless steel grills and a stone counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-412b-766d-ae23-20ea3b8194b1.webp"
    },
    {
      "id": "custom_22f8c543-2218-49f2-89cb-11d0c208a0bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-c866-71cf-bf5a-09b24207615a.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-building apartment community with walkways, trees, and desert landscaping.",
        "public_id": "019d20b9-c866-71cf-bf5a-09b24207615a",
        "storage_key": "property/6767906449167040/019d20b9-c866-71cf-bf5a-09b24207615a.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Exterior view of a resort-style apartment community with landscaped walkways, trees, and low-water gravel paths.",
      "link": "",
      "alt_text": "Exterior view of a multi-building apartment community with walkways, trees, and desert landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-95c3-77b4-9a4f-69102af43626.webp"
    },
    {
      "id": "custom_24c43eab-02a4-468b-9f14-69a573826b8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-c8d5-75ce-8000-534bc8f942e9.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily community courtyard with landscaped paths, stairs, and railings.",
        "public_id": "019d20b9-c8d5-75ce-8000-534bc8f942e9",
        "storage_key": "property/6767906449167040/019d20b9-c8d5-75ce-8000-534bc8f942e9.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Outdoor community space showcasing walkways, a central courtyard, and entry buildings for residents.",
      "link": "",
      "alt_text": "Exterior view of a multifamily community courtyard with landscaped paths, stairs, and railings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-95b3-77c1-8283-a986b9469950.webp"
    },
    {
      "id": "custom_b9aa9281-1abf-4620-a1f6-9e701e1a766b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-d819-765f-9208-493a1b5ca101.webp",
      "image_media": {
        "alt_text": "Outdoor community courtyard with a wooden pergola, benches, and a small play area.",
        "public_id": "019d20b9-d819-765f-9208-493a1b5ca101",
        "storage_key": "property/6767906449167040/019d20b9-d819-765f-9208-493a1b5ca101.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor community courtyard at a multifamily property featuring a wooden pergola, benches, and a children's play area.",
      "link": "",
      "alt_text": "Outdoor community courtyard with a wooden pergola, benches, and a small play area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-442f-765f-be50-f4a0f24051c6.webp"
    },
    {
      "id": "custom_9dafe045-4e1a-4d00-840e-82e8ad01b069",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-ddfd-7107-9f55-133e5607b017.webp",
      "image_media": {
        "alt_text": "Outdoor apartment community pool with blue lounge chairs and palm trees.",
        "public_id": "019d20b9-ddfd-7107-9f55-133e5607b017",
        "storage_key": "property/6767906449167040/019d20b9-ddfd-7107-9f55-133e5607b017.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Sunlit outdoor pool area at a multifamily community, surrounded by palm trees and lounge chairs.",
      "link": "",
      "alt_text": "Outdoor apartment community pool with blue lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-95ad-736b-9358-675198173788.webp"
    },
    {
      "id": "custom_7aa61fb9-74f5-4665-8204-7b29907677c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-de37-748b-b4a2-ea688d391b6e.webp",
      "image_media": {
        "alt_text": "Outdoor apartment community pool with palm trees and blue lounge chairs.",
        "public_id": "019d20b9-de37-748b-b4a2-ea688d391b6e",
        "storage_key": "property/6767906449167040/019d20b9-de37-748b-b4a2-ea688d391b6e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor pool area at a multifamily community with lounge chairs and palm trees.",
      "link": "",
      "alt_text": "Outdoor apartment community pool with palm trees and blue lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-45a7-772f-a9b5-a3d63ac9c117.webp"
    },
    {
      "id": "custom_9466491e-1660-4f75-ad06-5c88861d9802",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-e1c9-7519-a94f-7be20416fb7c.webp",
      "image_media": {
        "alt_text": "Open-concept lounge with sofa, fireplace, TV, and dining area in a clubhouse.",
        "public_id": "019d20b9-e1c9-7519-a94f-7be20416fb7c",
        "storage_key": "property/6767906449167040/019d20b9-e1c9-7519-a94f-7be20416fb7c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Spacious community clubhouse featuring a modern living area, fireplace, TV, and dining/bar seating for residents.",
      "link": "",
      "alt_text": "Open-concept lounge with sofa, fireplace, TV, and dining area in a clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-33a3-7535-a8b6-a8ecca2a3648.webp"
    },
    {
      "id": "custom_ec29a6e9-762e-4022-9a38-cc91f824cbac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-e766-750b-89d0-a11002f5f85b.webp",
      "image_media": {
        "alt_text": "Bright modern leasing office with sofa, large window, and a reception desk with two stools.",
        "public_id": "019d20b9-e766-750b-89d0-a11002f5f85b",
        "storage_key": "property/6767906449167040/019d20b9-e766-750b-89d0-a11002f5f85b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Contemporary community lobby featuring a reception desk, plush seating, and wood-look flooring.",
      "link": "",
      "alt_text": "Bright modern leasing office with sofa, large window, and a reception desk with two stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-5b0d-76cc-956c-2c82a28c8871.webp"
    },
    {
      "id": "custom_072ed77f-9867-47f6-97dc-31637ef54e2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-e904-757c-9809-905a35d7bccb.webp",
      "image_media": {
        "alt_text": "Indoor community dining/lounge area with a wooden table, chairs, shelves, and glass doors.",
        "public_id": "019d20b9-e904-757c-9809-905a35d7bccb",
        "storage_key": "property/6767906449167040/019d20b9-e904-757c-9809-905a35d7bccb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Bright amenity space with a dining area, seating, shelving, and large glass doors opening to outdoors.",
      "link": "",
      "alt_text": "Indoor community dining/lounge area with a wooden table, chairs, shelves, and glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-5b52-77e2-9feb-2b0d925596f2.webp"
    },
    {
      "id": "custom_64c27724-eb2d-4258-bb84-42df7e9dfee7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-e9f4-7672-bb33-15d1a38dba4a.webp",
      "image_media": {
        "alt_text": "Community laundry room with top-loading washers and stacked dryers.",
        "public_id": "019d20b9-e9f4-7672-bb33-15d1a38dba4a",
        "storage_key": "property/6767906449167040/019d20b9-e9f4-7672-bb33-15d1a38dba4a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "On-site communal laundry facility with multiple washers and stacked dryers for residents.",
      "link": "",
      "alt_text": "Community laundry room with top-loading washers and stacked dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-479b-779c-9802-2d04565ecebc.webp"
    },
    {
      "id": "custom_e210ed69-91fd-4f19-a4d9-b26bf0a77d48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-f28c-729c-a697-1e2ea1663cb2.webp",
      "image_media": {
        "alt_text": "Interior of a community gym with cardio machines and free weights.",
        "public_id": "019d20b9-f28c-729c-a697-1e2ea1663cb2",
        "storage_key": "property/6767906449167040/019d20b9-f28c-729c-a697-1e2ea1663cb2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern on-site fitness center in the community, featuring cardio machines, free weights, and benches.",
      "link": "",
      "alt_text": "Interior of a community gym with cardio machines and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3340-74da-be6c-7b1773d8bbca.webp"
    },
    {
      "id": "custom_b58bea12-1f48-4a5e-959a-f5cfb8503c1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-f30e-772e-b8ad-448846327009.webp",
      "image_media": {
        "alt_text": "Indoor residential gym with treadmills and weight machines.",
        "public_id": "019d20b9-f30e-772e-b8ad-448846327009",
        "storage_key": "property/6767906449167040/019d20b9-f30e-772e-b8ad-448846327009.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Fully equipped community fitness center with cardio and strength equipment for residents.",
      "link": "",
      "alt_text": "Indoor residential gym with treadmills and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-456a-7708-bc72-4b949d2840a2.webp"
    },
    {
      "id": "custom_839ed3f4-33bf-4971-b140-3ce26aaf1406",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-f33a-7129-ab94-1d185d4c7e5c.webp",
      "image_media": {
        "alt_text": "Interior of a community gym with treadmills and weight machines.",
        "public_id": "019d20b9-f33a-7129-ab94-1d185d4c7e5c",
        "storage_key": "property/6767906449167040/019d20b9-f33a-7129-ab94-1d185d4c7e5c.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "On-site fitness center with cardio and strength equipment for residents.",
      "link": "",
      "alt_text": "Interior of a community gym with treadmills and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-95be-7267-97b1-371ea475c1d8.webp"
    },
    {
      "id": "custom_8b31ca96-233f-4db2-b5f7-c4c66566e35c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-fc25-7340-a194-9ee85d5ef857.webp",
      "image_media": {
        "alt_text": "Interior garage with a blue sectional door, concrete floor, and an opening to the outdoors.",
        "public_id": "019d20b9-fc25-7340-a194-9ee85d5ef857",
        "storage_key": "property/6767906449167040/019d20b9-fc25-7340-a194-9ee85d5ef857.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Other",
      "description": "Modern garage interior in a multifamily building, featuring a blue sectional door and visible outdoor area.",
      "link": "",
      "alt_text": "Interior garage with a blue sectional door, concrete floor, and an opening to the outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-a2e0-7159-8bc3-e87a1a06d036.webp"
    },
    {
      "id": "custom_725b4136-4d0b-474b-b5db-a8d008b7e46d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-fc8b-7189-b44c-d5cb9bb81e7e.webp",
      "image_media": {
        "alt_text": "Compact apartment kitchen with beige cabinetry, stainless steel stove and microwave, and wall art.",
        "public_id": "019d20b9-fc8b-7189-b44c-d5cb9bb81e7e",
        "storage_key": "property/6767906449167040/019d20b9-fc8b-7189-b44c-d5cb9bb81e7e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with beige cabinets, stainless steel appliances, and framed wall art.",
      "link": "",
      "alt_text": "Compact apartment kitchen with beige cabinetry, stainless steel stove and microwave, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3952-748a-a6cf-f3ab8822a010.webp"
    },
    {
      "id": "custom_86bb7ed5-30fb-4321-8cbc-69e7a97df7e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-fcba-7176-bfde-3b6b57e22ad7.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a gray sofa, white chairs, a round mosaic coffee table, and a TV.",
        "public_id": "019d20b9-fcba-7176-bfde-3b6b57e22ad7",
        "storage_key": "property/6767906449167040/019d20b9-fcba-7176-bfde-3b6b57e22ad7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment living room featuring a gray sofa, white chairs, a round mosaic coffee table, and a TV on a wooden console.",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sofa, white chairs, a round mosaic coffee table, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3351-7306-9250-24f789f25ff4.webp"
    },
    {
      "id": "custom_bebee2fb-ee8c-4e95-8ed2-781357ccf0fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20b9-fcd6-744b-9805-c6a259fde49e.webp",
      "image_media": {
        "alt_text": "Bedroom with a dark wood bed, two nightstands, white bedding, and a sliding glass door to a balcony.",
        "public_id": "019d20b9-fcd6-744b-9805-c6a259fde49e",
        "storage_key": "property/6767906449167040/019d20b9-fcd6-744b-9805-c6a259fde49e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Neutral, modern apartment bedroom with balcony access and ample natural light.",
      "link": "",
      "alt_text": "Bedroom with a dark wood bed, two nightstands, white bedding, and a sliding glass door to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3373-702e-8500-99927391c572.webp"
    },
    {
      "id": "custom_c5522bc0-b1a8-466d-a36f-9817876227a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-03cc-748d-a739-5f24270fe800.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a gray sectional, wooden TV console, and round coffee table near a window.",
        "public_id": "019d20ba-03cc-748d-a739-5f24270fe800",
        "storage_key": "property/6767906449167040/019d20ba-03cc-748d-a739-5f24270fe800.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, neutrally decorated living area with seating, a media console, and natural light.",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sectional, wooden TV console, and round coffee table near a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3383-72ee-b2e4-d2cf3a2a9aa4.webp"
    },
    {
      "id": "custom_300fc4fa-0201-4d64-bb5a-ab4039e3dcb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-0608-735c-a677-8e894de1b34d.webp",
      "image_media": {
        "alt_text": "Neutral-toned apartment living room with a gray sofa, round coffee table, and doorway to a bedroom.",
        "public_id": "019d20ba-0608-735c-a677-8e894de1b34d",
        "storage_key": "property/6767906449167040/019d20ba-0608-735c-a677-8e894de1b34d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, neutral living area in an apartment with a gray sectional, wooden coffee table, and access to a bedroom.",
      "link": "",
      "alt_text": "Neutral-toned apartment living room with a gray sofa, round coffee table, and doorway to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-4221-74e9-8479-8d54f08a27e8.webp"
    },
    {
      "id": "custom_7bbe49f2-9e25-4f1c-b59e-0adf305e33af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-0e3c-701d-910d-de311968401b.webp",
      "image_media": {
        "alt_text": "Open-concept living room with a gray sofa, round coffee table, and adjacent kitchen/dining area.",
        "public_id": "019d20ba-0e3c-701d-910d-de311968401b",
        "storage_key": "property/6767906449167040/019d20ba-0e3c-701d-910d-de311968401b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Open-concept living area in a furnished apartment with a gray sofa and adjacent kitchen and dining space.",
      "link": "",
      "alt_text": "Open-concept living room with a gray sofa, round coffee table, and adjacent kitchen/dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-4744-7107-8dae-d850f0c810ee.webp"
    },
    {
      "id": "custom_dd70deb0-dc31-4013-af39-5802145388d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-0fee-723e-b998-aa3d5b049839.webp",
      "image_media": {
        "alt_text": "Compact apartment kitchen with beige cabinets, stainless steel stove and microwave, and white countertops.",
        "public_id": "019d20ba-0fee-723e-b998-aa3d5b049839",
        "storage_key": "property/6767906449167040/019d20ba-0fee-723e-b998-aa3d5b049839.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen with beige cabinets, stainless appliances, and white countertops.",
      "link": "",
      "alt_text": "Compact apartment kitchen with beige cabinets, stainless steel stove and microwave, and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-496b-7548-995b-87c8b2512203.webp"
    },
    {
      "id": "custom_0e1c9abd-1270-4df9-bec8-985f90404a3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-13be-706b-86de-f4387534e590.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a metal bed frame, nightstand, lamp, and window blinds.",
        "public_id": "019d20ba-13be-706b-86de-f4387534e590",
        "storage_key": "property/6767906449167040/019d20ba-13be-706b-86de-f4387534e590.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with neutral decor, natural light, metal bed frame, and simple wooden furnishings.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a metal bed frame, nightstand, lamp, and window blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-48fc-73da-83e6-1f4c2c50af9d.webp"
    },
    {
      "id": "custom_52f46c52-08ad-4b7c-8758-71358cab1bbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-1809-747d-80d1-1ce2f57e8c05.webp",
      "image_media": {
        "alt_text": "Communal dining area in a clubhouse with wooden tables, black chairs, and a kitchen alcove.",
        "public_id": "019d20ba-1809-747d-80d1-1ce2f57e8c05",
        "storage_key": "property/6767906449167040/019d20ba-1809-747d-80d1-1ce2f57e8c05.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Bright community dining room in a multifamily clubhouse with long wooden tables, black chairs, and an open kitchen area.",
      "link": "",
      "alt_text": "Communal dining area in a clubhouse with wooden tables, black chairs, and a kitchen alcove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-4ea9-745d-ab67-2a75ed5590de.webp"
    },
    {
      "id": "custom_9897bdc1-611c-479f-b51f-7745b7d5b796",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-1f10-7472-9fe5-ff38d992279f.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and tub with shower curtain.",
        "public_id": "019d20ba-1f10-7472-9fe5-ff38d992279f",
        "storage_key": "property/6767906449167040/019d20ba-1f10-7472-9fe5-ff38d992279f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with beige vanity, white fixtures, and wood-like flooring.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and tub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-522d-7038-9678-d86dabf36bf9.webp"
    },
    {
      "id": "custom_8fa4bf12-7ecb-48d3-b45d-c7c212a73c39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-24e7-7305-9a05-9dc79cb431b6.webp",
      "image_media": {
        "alt_text": "Dining area in an apartment with a wooden table, six chairs, and wall art.",
        "public_id": "019d20ba-24e7-7305-9a05-9dc79cb431b6",
        "storage_key": "property/6767906449167040/019d20ba-24e7-7305-9a05-9dc79cb431b6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious dining area in a modern apartment featuring a wooden table, seating for six, and decorative wall art.",
      "link": "",
      "alt_text": "Dining area in an apartment with a wooden table, six chairs, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-526a-74df-b74d-6dd41603871a.webp"
    },
    {
      "id": "custom_09ad6a40-07b0-48f6-a070-672aa46e0457",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-295f-7328-81a4-ddc43b669655.webp",
      "image_media": {
        "alt_text": "Bathroom with long beige vanity, toilet, and bathtub with orange-pattern curtain.",
        "public_id": "019d20ba-295f-7328-81a4-ddc43b669655",
        "storage_key": "property/6767906449167040/019d20ba-295f-7328-81a4-ddc43b669655.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with beige cabinetry, white tub/shower, and coastal decor.",
      "link": "",
      "alt_text": "Bathroom with long beige vanity, toilet, and bathtub with orange-pattern curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-53e8-71d0-aec3-b115494ef754.webp"
    },
    {
      "id": "custom_a63648ed-be77-4018-940b-1b39d568d35d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-2d90-731a-b50f-96ab0faf440e.webp",
      "image_media": {
        "alt_text": "Interior living room with two gray armchairs, two ottomans, and a window with blinds.",
        "public_id": "019d20ba-2d90-731a-b50f-96ab0faf440e",
        "storage_key": "property/6767906449167040/019d20ba-2d90-731a-b50f-96ab0faf440e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment living room with neutral furniture, wood-like flooring, and natural light.",
      "link": "",
      "alt_text": "Interior living room with two gray armchairs, two ottomans, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-5734-723c-928b-d7b85f914a58.webp"
    },
    {
      "id": "custom_b239894c-e3e3-471d-a082-89f515df1512",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-2dc7-738f-a32a-864c4e241de7.webp",
      "image_media": {
        "alt_text": "Dining area with wooden table, six black spindle chairs, a ceiling light, and built-in shelves.",
        "public_id": "019d20ba-2dc7-738f-a32a-864c4e241de7",
        "storage_key": "property/6767906449167040/019d20ba-2dc7-738f-a32a-864c4e241de7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A stylish apartment dining area featuring a wooden table, black spindle chairs, and built-in shelving with decorative accents.",
      "link": "",
      "alt_text": "Dining area with wooden table, six black spindle chairs, a ceiling light, and built-in shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-617b-7479-bf9a-f7835d014c4d.webp"
    },
    {
      "id": "custom_fac445d7-2eeb-4728-b718-f3a314c2ec4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-2f3d-72fb-85a8-44d41541eaaf.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment kitchen with a wood-topped island and four bar stools.",
        "public_id": "019d20ba-2f3d-72fb-85a8-44d41541eaaf",
        "storage_key": "property/6767906449167040/019d20ba-2f3d-72fb-85a8-44d41541eaaf.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A modern apartment kitchen featuring a wood island, four bar stools, and minimalist wall art.",
      "link": "",
      "alt_text": "Interior view of a modern apartment kitchen with a wood-topped island and four bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-61ec-73ed-bcf7-ba9fd3feb6e6.webp"
    },
    {
      "id": "custom_b32b1b5f-2893-4c27-9de9-1fa5c77486a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-333e-7501-932c-302cca3b8549.webp",
      "image_media": {
        "alt_text": "Communal dining area with a rustic wooden table, black chairs, and an adjacent kitchen.",
        "public_id": "019d20ba-333e-7501-932c-302cca3b8549",
        "storage_key": "property/6767906449167040/019d20ba-333e-7501-932c-302cca3b8549.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Bright communal dining area in the apartment community featuring a rustic wooden table, black chairs, and an adjacent kitchenette.",
      "link": "",
      "alt_text": "Communal dining area with a rustic wooden table, black chairs, and an adjacent kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-95b1-772a-84a5-50aa30ad7854.webp"
    },
    {
      "id": "custom_75cca795-f63a-48f0-bb4a-d1101f7b9dca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-3720-76f2-9417-6b724d04f870.webp",
      "image_media": {
        "alt_text": "Bedroom with a gray wooden bed, two nightstands, lamps, and an open bathroom to the left.",
        "public_id": "019d20ba-3720-76f2-9417-6b724d04f870",
        "storage_key": "property/6767906449167040/019d20ba-3720-76f2-9417-6b724d04f870.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright neutral bedroom in a modern apartment with a rustic wood bed, matching nightstands, lamps, and wall art.",
      "link": "",
      "alt_text": "Bedroom with a gray wooden bed, two nightstands, lamps, and an open bathroom to the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-95ad-736b-9358-6808d5d55465.webp"
    },
    {
      "id": "custom_1efe1fb1-1bd3-4303-91c1-6828bb00c077",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-3893-743b-bb45-10d787000064.webp",
      "image_media": {
        "alt_text": "Compact apartment kitchen with beige cabinets, stainless fridge, dishwasher, and double sink at a pass-through bar.",
        "public_id": "019d20ba-3893-743b-bb45-10d787000064",
        "storage_key": "property/6767906449167040/019d20ba-3893-743b-bb45-10d787000064.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Cozy kitchen in a rental apartment featuring stainless appliances, a double sink, and a pass-through breakfast bar to the living area.",
      "link": "",
      "alt_text": "Compact apartment kitchen with beige cabinets, stainless fridge, dishwasher, and double sink at a pass-through bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-9382-74fe-9d6e-e69536db34f7.webp"
    },
    {
      "id": "custom_701148a3-8d77-48e8-a33c-b8fc715551b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-3902-715e-964a-4c7a68482db4.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen with beige cabinets and stainless appliances; dining table in foreground with living area beyond.",
        "public_id": "019d20ba-3902-715e-964a-4c7a68482db4",
        "storage_key": "property/6767906449167040/019d20ba-3902-715e-964a-4c7a68482db4.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Open-concept apartment featuring a modern kitchen, wooden dining table, and a cozy living area.",
      "link": "",
      "alt_text": "Open-concept kitchen with beige cabinets and stainless appliances; dining table in foreground with living area beyond.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-961d-710c-8cd1-f2b0ca3b1b62.webp"
    },
    {
      "id": "custom_635f44b6-ef74-4da4-91ae-a9fedf12f11b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-4421-73fc-a799-21b7c219c4e3.webp",
      "image_media": {
        "alt_text": "Panoramic city skyline at sunset with tall buildings and foreground greenery.",
        "public_id": "019d20ba-4421-73fc-a799-21b7c219c4e3",
        "storage_key": "property/6767906449167040/019d20ba-4421-73fc-a799-21b7c219c4e3.webp",
        "width": 1998,
        "height": 749
      },
      "title": "Lifestyle",
      "description": "Downtown skyline at sunset, showcasing a vibrant mix of high-rise buildings and a sprawling urban landscape.",
      "link": "",
      "alt_text": "Panoramic city skyline at sunset with tall buildings and foreground greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-af75-71ab-88f4-23fe9f77815f.webp"
    },
    {
      "id": "custom_4fabb207-74b1-4c9d-8a6d-4356a63160a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-4a53-7578-8465-18951ca49a8d.webp",
      "image_media": {
        "alt_text": "Aerial view of a dense apartment complex with multiple buildings, parking, and distant mountains.",
        "public_id": "019d20ba-4a53-7578-8465-18951ca49a8d",
        "storage_key": "property/6767906449167040/019d20ba-4a53-7578-8465-18951ca49a8d.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "A modern apartment community with several buildings, parking, and scenic mountain views.",
      "link": "",
      "alt_text": "Aerial view of a dense apartment complex with multiple buildings, parking, and distant mountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-b24a-74e8-9979-1bb878620d73.webp"
    },
    {
      "id": "custom_6f7d7f5f-2408-4179-b72b-02c77b20699f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-5014-703b-81dd-d3119543b9cf.webp",
      "image_media": {
        "alt_text": "Close-up of a person’s hands holding a white travel mug beside a bicycle.",
        "public_id": "019d20ba-5014-703b-81dd-d3119543b9cf",
        "storage_key": "property/6767906449167040/019d20ba-5014-703b-81dd-d3119543b9cf.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Lifestyle image of a resident with a white travel mug beside a bicycle, conveying an active, outdoor-friendly apartment living vibe.",
      "link": "",
      "alt_text": "Close-up of a person’s hands holding a white travel mug beside a bicycle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-b251-72eb-94c1-8ef5bae20fae.webp"
    },
    {
      "id": "custom_0fc2a409-bbcd-4ae1-9537-6878e5cc76b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d20ba-52bf-77fd-95d9-4495083f2eb9.webp",
      "image_media": {
        "alt_text": "Children with backpacks line up to board a yellow school bus outdoors.",
        "public_id": "019d20ba-52bf-77fd-95d9-4495083f2eb9",
        "storage_key": "property/6767906449167040/019d20ba-52bf-77fd-95d9-4495083f2eb9.webp",
        "width": 788,
        "height": 663
      },
      "title": "Lifestyle",
      "description": "A family-friendly scene of kids boarding a school bus, highlighting convenient transportation for residents.",
      "link": "",
      "alt_text": "Children with backpacks line up to board a yellow school bus outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167040/019cfb51-b24e-72e8-9914-d05f78f9e1ee.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_691e11bb-b97b-4c76-8b63-c54f02eeb33f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Topgolf El Paso",
      "poi_type": "Restaurants",
      "poi_address": "365 Vin Rambla Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with a variety of games and tasty food. They highlight the lively atmosphere, perfect for outings with family and friends, and the friendly staff. They also like the availability of heat in every bay and the option to book reservations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-0f15-72b9-80ab-208a4680301b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0f15-72b9-80ab-208a4680301b",
        "storage_key": "property/6767906449167040/019d270e-0f15-72b9-80ab-208a4680301b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://topgolf.com/us/el-paso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10477886874640848166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-el-paso",
      "poi_latitude": "31.8107961",
      "poi_longitude": "-106.5250411",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-845-9028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-40b5-724f-8a0a-72e403301da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-40b5-724f-8a0a-72e403301da1",
        "storage_key": "property/6767906449167040/019d270e-40b5-724f-8a0a-72e403301da1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxkkkflX54YRJhWyJ5nuaJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fea3b5b6-29e7-44d1-a5e6-2878babe4e83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "L & J Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3622 E Missouri Ave, El Paso, TX 79903, USA",
      "poi_short_description": "A local landmark dating back to 1927, this family-run eatery serves regional Mexican dishes & beers.",
      "poi_long_description": "People say this Mexican restaurant serves delicious and flavorful dishes, including enchiladas, burritos, and tacos. They highlight the reasonable prices, generous portions, and authentic, family-owned atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-0efe-704e-b703-277a62ca5904.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0efe-704e-b703-277a62ca5904",
        "storage_key": "property/6767906449167040/019d270e-0efe-704e-b703-277a62ca5904.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://ljcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=253529114313290020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "l--j-cafe",
      "poi_latitude": "31.7795154",
      "poi_longitude": "-106.4497953",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-566-8418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-40b5-724f-8a0a-72e403301da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-40b5-724f-8a0a-72e403301da1",
        "storage_key": "property/6767906449167040/019d270e-40b5-724f-8a0a-72e403301da1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy58M-oRZ54YRJPHc3mK3hAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_2ef48b76-e538-4d8c-bb8e-f282deb04355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Taconeta",
      "poi_type": "Restaurants",
      "poi_address": "311 Montana Ave A-1, El Paso, TX 79902, USA",
      "poi_short_description": "Classic Mexican plates doled out in an unpretentious restaurant with an airy dining room.",
      "poi_long_description": "People say this taco restaurant serves delicious brisket, chicken, shrimp, and mushroom tacos, as well as elote, fried green beans, and sweet potatoes. They highlight the fresh ingredients, flavorful salsas, and unique take on Mexican food. They also like the friendly and efficient service, and the vibrant, fun atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-0f13-70da-95f3-d06e57fa9e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0f13-70da-95f3-d06e57fa9e23",
        "storage_key": "property/6767906449167040/019d270e-0f13-70da-95f3-d06e57fa9e23.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.toasttab.com/taconeta",
      "poi_directions_map_url": "https://maps.google.com/?cid=10960950357964817459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taconeta",
      "poi_latitude": "31.7648439",
      "poi_longitude": "-106.4904197",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-303-8038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-40b5-724f-8a0a-72e403301da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-40b5-724f-8a0a-72e403301da1",
        "storage_key": "property/6767906449167040/019d270e-40b5-724f-8a0a-72e403301da1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_NrqhpZ54YRMwQv50YeHZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3841fa78-625b-4561-be37-f9ab73c81889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Salt + Honey Bakery Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1125 Texas Ave, El Paso, TX 79901, USA",
      "poi_short_description": "Cool, brick-lined locale with a creative cafe menu, cold-pressed juices & locally roasted coffee.",
      "poi_long_description": "People say this breakfast restaurant serves delicious chicken and waffles, eggs benedict, and baklava pancakes. They also highlight the unique coffee and tea menu, and the attentive and friendly staff.\n\nOther reviews mention the wait time can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-0fab-72f8-b046-59b5e93bc5b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0fab-72f8-b046-59b5e93bc5b0",
        "storage_key": "property/6767906449167040/019d270e-0fab-72f8-b046-59b5e93bc5b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.saltandhoneyep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866789244147418890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt--honey-bakery-cafe",
      "poi_latitude": "31.7648676",
      "poi_longitude": "-106.4783652",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-313-4907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-40b5-724f-8a0a-72e403301da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-40b5-724f-8a0a-72e403301da1",
        "storage_key": "property/6767906449167040/019d270e-40b5-724f-8a0a-72e403301da1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG7y4m5dZ54YRCkcZPghPikM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_45b1ac44-7ad6-4253-bf16-bdeca7088c80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "5010 N Desert Blvd, El Paso, TX 79912, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and loaded mashed potatoes, and the rolls are amazing. They highlight the great value and lively, energetic atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-1473-7177-8601-ad48a166f036.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1473-7177-8601-ad48a166f036",
        "storage_key": "property/6767906449167040/019d270e-1473-7177-8601-ad48a166f036.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/el-paso-n-desert-blvd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=2594805389550251164&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.8404434",
      "poi_longitude": "-106.5685133",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-832-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-40b5-724f-8a0a-72e403301da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-40b5-724f-8a0a-72e403301da1",
        "storage_key": "property/6767906449167040/019d270e-40b5-724f-8a0a-72e403301da1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ684Xlln43YYRnGxpAcGZAiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_98a01ece-28a5-4edc-a01d-edfe1f4311ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 Pitt St, El Paso, TX 79912, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of organic foods, fresh produce, and baked goods, including a popular hot bar and pizza. They highlight the clean and modern atmosphere, and the convenient amenities such as a bread slicer and Amazon return area. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-1372-7037-bee7-6d641d7d264a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1372-7037-bee7-6d641d7d264a",
        "storage_key": "property/6767906449167040/019d270e-1372-7037-bee7-6d641d7d264a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/elpaso?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5575333113701639611&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "31.8340462",
      "poi_longitude": "-106.5480013",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-236-1420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4050-707c-a0b5-dc8102fea5ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4050-707c-a0b5-dc8102fea5ce",
        "storage_key": "property/6767906449167040/019d270e-4050-707c-a0b5-dc8102fea5ce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj13blm_43YYRu6Wocu2PX00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_dc69f103-45ea-470a-91c0-120868241102",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "The Shoppes at Solana",
      "poi_type": "Shopping & Retail",
      "poi_address": "750 Sunland Park Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Prominent indoor shopping center with 100+ stores on 2 levels, plus chain restaurants & a theater.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including kid-friendly options and unique businesses. They also highlight the spacious layout, clean environment, and fun activities, such as a petting zoo and fireworks displays.\n\nOther reviews mention the mall can be empty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-13d6-728d-9edb-e7b8209edd44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-13d6-728d-9edb-e7b8209edd44",
        "storage_key": "property/6767906449167040/019d270e-13d6-728d-9edb-e7b8209edd44.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "http://theshoppesatsolana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2107962478139008266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-shoppes-at-solana",
      "poi_latitude": "31.8144216",
      "poi_longitude": "-106.5440443",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-833-5596",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4058-7189-a534-86127484e350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4058-7189-a534-86127484e350",
        "storage_key": "property/6767906449167040/019d270e-4058-7189-a534-86127484e350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoWrRgA_43YYRCuVTlbT8QB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c383b674-7a2a-4759-81cd-2278eee75241",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7545 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store is well-stocked and the staff is helpful and knowledgeable. They also highlight the friendly and attentive service, making it a pleasant shopping experience.\n\nSome reviews mention the wait times for assistance can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-145d-768b-87a7-38c5ee0e3d15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-145d-768b-87a7-38c5ee0e3d15",
        "storage_key": "property/6767906449167040/019d270e-145d-768b-87a7-38c5ee0e3d15.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/West-El-Paso/TX/El-Paso/79912/523?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7694583817001495963&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "31.835826",
      "poi_longitude": "-106.5642035",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-585-2319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4058-7189-a534-86127484e350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4058-7189-a534-86127484e350",
        "storage_key": "property/6767906449167040/019d270e-4058-7189-a534-86127484e350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8zsx0lv43YYRm-3XwjanyGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_23c134e2-dc39-4cff-9c0d-82daa6686302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "430 Redd Rd, El Paso, TX 79912, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products for home improvement projects. They also highlight the store's layout is easy to navigate and the staff is friendly.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-17d2-775e-9cd4-0bc5b13312d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-17d2-775e-9cd4-0bc5b13312d8",
        "storage_key": "property/6767906449167040/019d270e-17d2-775e-9cd4-0bc5b13312d8.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-El-Paso/1152?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1152-_-na-_-0-_-0&y_source=1_MTE4NDM4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5332424068888550467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "31.86153",
      "poi_longitude": "-106.57317",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-581-4401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4058-7189-a534-86127484e350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4058-7189-a534-86127484e350",
        "storage_key": "property/6767906449167040/019d270e-4058-7189-a534-86127484e350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUewuiOb43YYRQ1zYMXCTAEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_a9bfea50-5957-43d5-a48d-0e2844d8044b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Fort Bliss - Exchange",
      "poi_type": "Shopping & Retail",
      "poi_address": "1611 Haan Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Shopping mall at Freedom Crossing at Fort Bliss with a food court and tax-free bonus savings for military members and veterans.",
      "poi_long_description": "People say this shopping center offers a huge selection of products and services, and a food court with fantastic choices. They highlight the clean and well-organized layout, and the great prices. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-18ce-738a-a903-2039e37e0c32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-18ce-738a-a903-2039e37e0c32",
        "storage_key": "property/6767906449167040/019d270e-18ce-738a-a903-2039e37e0c32.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.shopmyexchange.com/exchange-stores/United%20States/TX/Ft.%20Bliss/Ft-Bliss--1011801",
      "poi_directions_map_url": "https://maps.google.com/?cid=10221724360285077533&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss---exchange",
      "poi_latitude": "31.8180883",
      "poi_longitude": "-106.4295632",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 915-562-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4058-7189-a534-86127484e350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4058-7189-a534-86127484e350",
        "storage_key": "property/6767906449167040/019d270e-4058-7189-a534-86127484e350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ83LPBZ9Z54YRHcC_Dibc2o0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9ed26d74-aff5-4673-9adf-e676ca71c497",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "University of Texas at El Paso",
      "poi_type": "Education",
      "poi_address": "500 W University Ave, El Paso, TX 79968, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-1a33-705e-b8ad-0106113bac23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1a33-705e-b8ad-0106113bac23",
        "storage_key": "property/6767906449167040/019d270e-1a33-705e-b8ad-0106113bac23.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.utep.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15130569928881990844&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-texas-at-el-paso",
      "poi_latitude": "31.7731979",
      "poi_longitude": "-106.5047208",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-747-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4057-7113-8051-c365fdb3bd46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4057-7113-8051-c365fdb3bd46",
        "storage_key": "property/6767906449167040/019d270e-4057-7113-8051-c365fdb3bd46.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ12KA7lpY54YRvOw3ZC-V-tE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dd752a38-bd6d-4f14-9f26-c159b5beb534",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "University Library",
      "poi_type": "Education",
      "poi_address": "1900 Wiggins Rd, El Paso, TX 79968, USA",
      "poi_short_description": "University library with free admission and study space, plus a coffee shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-1976-726a-b2b2-119a2278343f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1976-726a-b2b2-119a2278343f",
        "storage_key": "property/6767906449167040/019d270e-1976-726a-b2b2-119a2278343f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utep.edu/library",
      "poi_directions_map_url": "https://maps.google.com/?cid=16419899299576992938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-library",
      "poi_latitude": "31.7673517",
      "poi_longitude": "-106.5047201",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-747-5672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4480-71ab-bc67-92636bc087f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4480-71ab-bc67-92636bc087f6",
        "storage_key": "property/6767906449167040/019d270e-4480-71ab-bc67-92636bc087f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7gl1lhY54YRqtT4pmoz3-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_a7e81276-4547-4df9-86e0-3f8e21bda947",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "El Paso Community College - Rio Grande Campus - EPCC RG",
      "poi_type": "Education",
      "poi_address": "100 W Rio Grande Ave, El Paso, TX 79902, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-1c78-7654-a63e-47ac949846b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1c78-7654-a63e-47ac949846b6",
        "storage_key": "property/6767906449167040/019d270e-1c78-7654-a63e-47ac949846b6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://epcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9387787273262637608&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-community-college---rio-grande-campus---epcc-rg",
      "poi_latitude": "31.763854",
      "poi_longitude": "-106.493823",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-831-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4057-7113-8051-c365fdb3bd46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4057-7113-8051-c365fdb3bd46",
        "storage_key": "property/6767906449167040/019d270e-4057-7113-8051-c365fdb3bd46.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4VKH0vhY54YRKKLAUckeSII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_aa112a55-c645-4bbc-9769-35852a62435c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Sun Bowl",
      "poi_type": "Entertainment",
      "poi_address": "2701 Sun Bowl Dr, El Paso, TX 79902, USA",
      "poi_short_description": "University of Texas El Paso Miners' 51,500-seat outdoor football arena & site of the Sun Bowl game.",
      "poi_long_description": "People say this stadium offers a great experience for concerts, football games, and other events, with a beautiful setting carved into a mountain overlooking the city. They highlight the smooth traffic flow, well-maintained facilities, and helpful staff. They also like the fun-loving crowd and the sense of pride in the venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-1dd7-70f7-b6c4-bbd94213183f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1dd7-70f7-b6c4-bbd94213183f",
        "storage_key": "property/6767906449167040/019d270e-1dd7-70f7-b6c4-bbd94213183f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.utepspecialevents.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12740333998005602376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sun-bowl",
      "poi_latitude": "31.7733442",
      "poi_longitude": "-106.5079256",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4455-73cb-a00d-115593c6ec7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4455-73cb-a00d-115593c6ec7d",
        "storage_key": "property/6767906449167040/019d270e-4455-73cb-a00d-115593c6ec7d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ3x541xY54YRSMj0HkXCzrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_9e67e111-7064-40b0-82b2-23def8b8dafd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Don Haskins Center",
      "poi_type": "Entertainment",
      "poi_address": "151 Glory Rd, El Paso, TX 79902, USA",
      "poi_short_description": "Arena hosting big concerts and other events with food, drink, and free parking.",
      "poi_long_description": "People say this arena is a great place for graduations and other events, and can hold a large number of people. They highlight the great atmosphere and the convenient concession stand. They also like the helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-1eb2-736f-8d49-176be36e5272.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1eb2-736f-8d49-176be36e5272",
        "storage_key": "property/6767906449167040/019d270e-1eb2-736f-8d49-176be36e5272.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utepspecialevents.com/venues/don_haskins_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11992951360778632993&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-haskins-center",
      "poi_latitude": "31.7776195",
      "poi_longitude": "-106.5056719",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-747-5481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46MilERY54YRIX-_o7iFb6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_75e52539-2645-464c-ad5f-11fddead6237",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "La Nube STEAM Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "201 W Main Dr, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this museum offers a variety of interactive exhibits, including a water play area, a climbing structure, and a toddler area, as well as costumes and STEAM activities. They highlight the family-friendly vibe, the educational and entertaining experience, and the clean facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-1f58-7275-8a05-6739aeeca279.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1f58-7275-8a05-6739aeeca279",
        "storage_key": "property/6767906449167040/019d270e-1f58-7275-8a05-6739aeeca279.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.la-nube.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5422886930183727470&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-nube-steam-discovery-center",
      "poi_latitude": "31.7590797",
      "poi_longitude": "-106.4906986",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-290-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448a-7090-8aa9-918dd645e32c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448a-7090-8aa9-918dd645e32c",
        "storage_key": "property/6767906449167040/019d270e-448a-7090-8aa9-918dd645e32c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJTzDNKgBZ54YRbqm1au72QUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3a7f6791-517b-4e6a-906d-526a12484d6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "San Jacinto Plaza",
      "poi_type": "Entertainment",
      "poi_address": "114 W Mills Ave, El Paso, TX 79901, USA",
      "poi_short_description": "Tranquil city plaza featuring quaint, tended green spaces, park benches, shade trees & a snack bar.",
      "poi_long_description": "People say this plaza offers beautiful Christmas lights and a great outdoor experience. They highlight the well-maintained area, spacious layout, and family-friendly atmosphere. They also like the lively and fun vibe, especially during events like Winter Fest.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-22d8-76e6-bf48-cd8d02f8a21e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-22d8-76e6-bf48-cd8d02f8a21e",
        "storage_key": "property/6767906449167040/019d270e-22d8-76e6-bf48-cd8d02f8a21e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://new.elpasotexas.gov/parks-and-recreation/aquatics/spray-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5702780616355707890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-jacinto-plaza",
      "poi_latitude": "31.7596192",
      "poi_longitude": "-106.4885225",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-534-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaSf1kv1Y54YR8nvdhcFYJE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_a11ab8f2-ae02-4ff4-a313-2ec2ffba42ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "801 S Mesa Hills Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of attractions, including trampolines, obstacle courses, and a zip line, and that the food, especially the pizza, is decent. They also highlight the family-friendly atmosphere, the reasonable prices, and the fun experience for both kids and adults.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-22ff-75dc-a481-14a32276e642.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-22ff-75dc-a481-14a32276e642",
        "storage_key": "property/6767906449167040/019d270e-22ff-75dc-a481-14a32276e642.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/texas-west-el-paso/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=9791591556466300534&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "31.81827539999999",
      "poi_longitude": "-106.5405754",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-263-8277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2yyOdb53YYRdlbjfKS44oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_01e2f82c-5bcc-456d-97d3-65010f00f58e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Kinective Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 Belvidere St, El Paso, TX 79912, USA",
      "poi_short_description": "Modern gym with state-of-the-art machines, spa amenities and fitness classes, plus personal training.",
      "poi_long_description": "People say this fitness center offers a wide variety of classes and top-notch equipment. They highlight the clean and spacious facility, and the motivating and welcoming environment. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-23b5-711c-9fbd-93083be0d97e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-23b5-711c-9fbd-93083be0d97e",
        "storage_key": "property/6767906449167040/019d270e-23b5-711c-9fbd-93083be0d97e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://kinective.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=844899700064661306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kinective-fitness-club",
      "poi_latitude": "31.8521899",
      "poi_longitude": "-106.5401454",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-260-9895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSrKKj753YYROi8w_cyvuQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_df3002e1-a573-4432-b9ad-4be7bbc77abe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5700 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Chain gym with a variety of equipment, tanning, and massage services, plus 24-hour access.",
      "poi_long_description": "People say this gym offers a variety of equipment, including weight machines, free weights, and an abdomen room. They also highlight the convenient locations, clean facilities, and friendly staff.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-250c-710f-8ca1-764998d01f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-250c-710f-8ca1-764998d01f60",
        "storage_key": "property/6767906449167040/019d270e-250c-710f-8ca1-764998d01f60.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/el-paso-mesa-hills-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6859376139751605018&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.8241974",
      "poi_longitude": "-106.5208557",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-585-7867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bh0xehX54YRGkOvrkFmMV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e73e8916-cc8a-4939-9213-08397efa4395",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs",
      "poi_type": "Health and Wellness",
      "poi_address": "750 Sunland Park Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Premium health club offering classes and training sessions in a welcoming atmosphere featuring fitness equipment and a turf area.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including Hammer Strength machines, and has clean shower facilities. They highlight the great operating hours and friendly staff. They also like the positive and motivating atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-27cb-76b9-8464-0984a8c64fb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-27cb-76b9-8464-0984a8c64fb5",
        "storage_key": "property/6767906449167040/019d270e-27cb-76b9-8464-0984a8c64fb5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trufitathleticclubs.com/gym-near-me/tru-fit-texas/el-paso/sunland-mall/&utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15276080860203553813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs",
      "poi_latitude": "31.8145396",
      "poi_longitude": "-106.5462017",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-300-1993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1_VFxT53YYRFZSTMJuK_9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_52ff801b-fe79-4b62-981a-44b38c7688c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "El Paso Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "6910 N Mesa St Ste H Suite D, El Paso, TX 79912, USA",
      "poi_short_description": "Gymnastics center with USA Gymnastics-certified coaches offering classes for all levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-27c0-74df-8899-1c023c98990e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-27c0-74df-8899-1c023c98990e",
        "storage_key": "property/6767906449167040/019d270e-27c0-74df-8899-1c023c98990e.webp",
        "width": 1008,
        "height": 567
      },
      "poi_business_url": "https://elpasogymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1102495125243281967&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-gymnastics",
      "poi_latitude": "31.8356392",
      "poi_longitude": "-106.5482103",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-581-3476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4057-7113-8051-c365fdb3bd46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4057-7113-8051-c365fdb3bd46",
        "storage_key": "property/6767906449167040/019d270e-4057-7113-8051-c365fdb3bd46.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg6HzWWX43YYRL8K5onnZTA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d173eb36-bb3b-49cd-9460-8302ec69d083",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "981 N Resler Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Gym chain with free weights and cardio machines, plus group fitness classes and saunas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-28fe-77de-9ff2-c7780012ccca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-28fe-77de-9ff2-c7780012ccca",
        "storage_key": "property/6767906449167040/019d270e-28fe-77de-9ff2-c7780012ccca.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/tx/el-paso-resler/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7817928767867659509&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "31.86318139999999",
      "poi_longitude": "-106.5590516",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-760-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99A4Bwz53YYR9SQPEMvcfmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3ad7ebce-f5e2-48d0-977b-9b8fd9da7216",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "El Paso Animal Urgent Care West",
      "poi_type": "Health and Wellness",
      "poi_address": "5500 N Desert Blvd, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-2af6-7016-9214-d9b089a31e66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2af6-7016-9214-d9b089a31e66",
        "storage_key": "property/6767906449167040/019d270e-2af6-7016-9214-d9b089a31e66.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://elpasoanimalurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8021225143916288949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-animal-urgent-care-west",
      "poi_latitude": "31.8592417",
      "poi_longitude": "-106.575303",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-301-0065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-crCu353YYRtduPJsUdUW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_9307cae8-5f44-4dfa-9f5c-e92964a2f2cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Crossroads Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4910 Crossroads Dr, El Paso, TX 79922, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-2c63-709e-8734-a1939ca10f6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2c63-709e-8734-a1939ca10f6b",
        "storage_key": "property/6767906449167040/019d270e-2c63-709e-8734-a1939ca10f6b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.xroadsvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=684506271961471425&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crossroads-animal-hospital",
      "poi_latitude": "31.8389216",
      "poi_longitude": "-106.5776014",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-584-3459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVV9PE1T43YYRwVnK4tPafwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_897d1e1f-0eae-4e5e-b025-c977cccd755f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Sun City Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "110 W Borderland Rd building B, El Paso, TX 79932, USA",
      "poi_short_description": "Welcoming gym outfitted with plenty of equipment, plus friendly staff and trainers.",
      "poi_long_description": "People say this gym offers a wide variety of equipment with no lines or wait times. They highlight the positive, encouraging, and family-like vibe, and the affordable pricing, especially for military personnel. They also like the helpful and respectful staff and owners.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-2d67-7556-a5d2-b25193a74e9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2d67-7556-a5d2-b25193a74e9d",
        "storage_key": "property/6767906449167040/019d270e-2d67-7556-a5d2-b25193a74e9d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.suncityathleticclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8910168082972694796&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sun-city-athletic-club",
      "poi_latitude": "31.8856259",
      "poi_longitude": "-106.5980758",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-273-7577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ12sX8i353YYRDFmc0qlGp3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_07d6ffd5-e2d3-43aa-8805-7de53105ccc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Las Palmas Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 N Oregon St, El Paso, TX 79902, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-2dde-728a-a696-08403a3f57d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2dde-728a-a696-08403a3f57d2",
        "storage_key": "property/6767906449167040/019d270e-2dde-728a-a696-08403a3f57d2.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://laspalmasdelsolhealthcare.com/locations/las-palmas-medical-center/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7797277200056017172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "las-palmas-medical-center",
      "poi_latitude": "31.7699653",
      "poi_longitude": "-106.4987868",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-521-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-48f2-77f9-838e-ae3adfc7d707.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-48f2-77f9-838e-ae3adfc7d707",
        "storage_key": "property/6767906449167040/019d270e-48f2-77f9-838e-ae3adfc7d707.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3k-QVdY54YRFGGXPE1-NWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1679c4e9-b864-43a8-9148-a9d87dc1ac7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "The Hospitals of Providence Sierra Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "1625 Medical Center St Drive, El Paso, TX 79902, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-2f7d-7604-812d-4cbb0bd7f27e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2f7d-7604-812d-4cbb0bd7f27e",
        "storage_key": "property/6767906449167040/019d270e-2f7d-7604-812d-4cbb0bd7f27e.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.thehospitalsofprovidence.com/locations/detail/sierra-campus/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-thop-sierra-campus&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1587269220917559167&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-hospitals-of-providence-sierra-campus",
      "poi_latitude": "31.777699",
      "poi_longitude": "-106.4808984",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-747-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-48f2-77f9-838e-ae3adfc7d707.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-48f2-77f9-838e-ae3adfc7d707",
        "storage_key": "property/6767906449167040/019d270e-48f2-77f9-838e-ae3adfc7d707.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQaz3G65Z54YRf7-zW_IcBxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_192021b8-b948-439b-89f7-91f5bc0cffd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Franklin Mountains State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 Tom Mays Park Access Rd, El Paso, TX 79911, USA",
      "poi_short_description": "24,247 acres of scenic desert offering climbing, hiking, wildlife, camping & views.",
      "poi_long_description": "People say this state park offers breathtaking views, well-maintained trails suitable for all skill levels, and opportunities for hiking, camping, and exploring caves. They highlight the peaceful and serene atmosphere, perfect for reconnecting with nature, and the friendly and helpful staff. They also like the well-marked trails and informative signage.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-3155-76ef-91bc-0c0caa40e802.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3155-76ef-91bc-0c0caa40e802",
        "storage_key": "property/6767906449167040/019d270e-3155-76ef-91bc-0c0caa40e802.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/franklin-mountains",
      "poi_directions_map_url": "https://maps.google.com/?cid=2199656840794880227&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "franklin-mountains-state-park",
      "poi_latitude": "31.9105609",
      "poi_longitude": "-106.518116",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-444-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-48b0-75b9-b0e7-c5f6fb1cf530.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-48b0-75b9-b0e7-c5f6fb1cf530",
        "storage_key": "property/6767906449167040/019d270e-48b0-75b9-b0e7-c5f6fb1cf530.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc0ThtdV54YR4zhWDz7Ahh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_6a828a95-024b-4478-af77-f0c3e4591332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1701 N Copia St, El Paso, TX 79930, USA",
      "poi_short_description": "Community park with trails, lighted softball field, tennis courts, playground & a swimming pool.",
      "poi_long_description": "People say this city park offers plenty of grass for picnics and games, a playground, and shade from numerous trees. They highlight the peaceful and relaxing vibe, and the well-maintained grounds. They also like the nearby ice cream truck and library branch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-323c-73c9-acc4-135d1c81aa57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-323c-73c9-acc4-135d1c81aa57",
        "storage_key": "property/6767906449167040/019d270e-323c-73c9-acc4-135d1c81aa57.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=615165719072263059&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "31.7894065",
      "poi_longitude": "-106.4571558",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-48b0-75b9-b0e7-c5f6fb1cf530.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-48b0-75b9-b0e7-c5f6fb1cf530",
        "storage_key": "property/6767906449167040/019d270e-48b0-75b9-b0e7-c5f6fb1cf530.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_YWrJNZ54YRk8tMU_aBiQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7b1444d9-f4fa-4dac-a55f-4e9f667520ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Braden Aboud Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4325 River Bend Dr, El Paso, TX 79922, USA",
      "poi_short_description": "Shady park hosting baseball games and sporting a playground, skate park and splash pad.",
      "poi_long_description": "People say this park offers a splash pad, playground, skate park, basketball court, and water park, with plenty of grass and trees for shade. They highlight the spaciousness, the availability of rental areas for parties and cookouts, and the nostalgic feel. They also like the clean facilities and wheelchair accessibility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-329d-75c8-b82c-2e4cd83da329.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-329d-75c8-b82c-2e4cd83da329",
        "storage_key": "property/6767906449167040/019d270e-329d-75c8-b82c-2e4cd83da329.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=8373575647336361708&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "braden-aboud-memorial-park",
      "poi_latitude": "31.8215355",
      "poi_longitude": "-106.5734406",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-48b0-75b9-b0e7-c5f6fb1cf530.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-48b0-75b9-b0e7-c5f6fb1cf530",
        "storage_key": "property/6767906449167040/019d270e-48b0-75b9-b0e7-c5f6fb1cf530.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD8kFLDb43YYR7G5Yp6_qNHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_acdf85e1-816a-47d0-9021-f20275a85067",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Madeline Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 E Baltimore Dr, El Paso, TX 79902, USA",
      "poi_short_description": "Relaxed park featuring tennis, basketball and playgrounds along with swings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-3494-7078-ad2f-3f46ad055b2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3494-7078-ad2f-3f46ad055b2b",
        "storage_key": "property/6767906449167040/019d270e-3494-7078-ad2f-3f46ad055b2b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=15087808784719380173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madeline-park",
      "poi_latitude": "31.7834094",
      "poi_longitude": "-106.4974639",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-212-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-48b0-75b9-b0e7-c5f6fb1cf530.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-48b0-75b9-b0e7-c5f6fb1cf530",
        "storage_key": "property/6767906449167040/019d270e-48b0-75b9-b0e7-c5f6fb1cf530.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQFO20hY54YRzX43rCaqYtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_844426a8-0a5e-4618-8b29-69b84878b893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Tom Lea Upper Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 Rim Rd, El Paso, TX 79902, USA",
      "poi_short_description": "Small city park & events site known for its sweeping mountain & city views.",
      "poi_long_description": "People say this city park offers clean walking paths, green grass and trees, and plenty of spots to sit and relax. They highlight the beautiful views, especially at night, and the peaceful, welcoming atmosphere. They also like the convenient parking and amenities, such as a playground, picnic pavilion, and dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-3619-77aa-b66a-75465cb77f91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3619-77aa-b66a-75465cb77f91",
        "storage_key": "property/6767906449167040/019d270e-3619-77aa-b66a-75465cb77f91.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=3374900840746437738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tom-lea-upper-park",
      "poi_latitude": "31.7749271",
      "poi_longitude": "-106.4913005",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-48b0-75b9-b0e7-c5f6fb1cf530.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-48b0-75b9-b0e7-c5f6fb1cf530",
        "storage_key": "property/6767906449167040/019d270e-48b0-75b9-b0e7-c5f6fb1cf530.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw7jZQlJY54YRaszbBG8O1i4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dba596bb-e04e-416f-bf32-3b01c0a1a8de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "El Paso, Texas",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W San Francisco Ave, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-36a1-778c-8482-eb6f8a39a991.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-36a1-778c-8482-eb6f8a39a991",
        "storage_key": "property/6767906449167040/019d270e-36a1-778c-8482-eb6f8a39a991.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=ELP",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091980658630256344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-texas",
      "poi_latitude": "31.75779249999999",
      "poi_longitude": "-106.4959672",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4883-7002-8ebf-b39a4c8e3abe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4883-7002-8ebf-b39a4c8e3abe",
        "storage_key": "property/6767906449167040/019d270e-4883-7002-8ebf-b39a4c8e3abe.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8VMdftY54YR2OaAEdrpMu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_9c8a1d98-4ae7-435a-a9a6-cc3908666e60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "El Paso City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 N Campbell St, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-3793-77ac-8934-6cde141b1aee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3793-77ac-8934-6cde141b1aee",
        "storage_key": "property/6767906449167040/019d270e-3793-77ac-8934-6cde141b1aee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasotexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7004826674061616697&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-city-hall",
      "poi_latitude": "31.7618251",
      "poi_longitude": "-106.4853072",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-212-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-4480-71ab-bc67-92636bc087f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4480-71ab-bc67-92636bc087f6",
        "storage_key": "property/6767906449167040/019d270e-4480-71ab-bc67-92636bc087f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8RKcPxY54YROaafNL8kNmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_756bb4d4-fda0-43ae-9860-50ea67227212",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "WestStar Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 N Mesa St, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-393e-74bd-91c0-57af250909c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-393e-74bd-91c0-57af250909c2",
        "storage_key": "property/6767906449167040/019d270e-393e-74bd-91c0-57af250909c2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.weststartower.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17936696281012297070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "weststar-tower",
      "poi_latitude": "31.7619103",
      "poi_longitude": "-106.4902384",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-532-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0X5dzG9Z54YRbt3OITzy6_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6d39c3aa-a1ae-47da-9b7d-cd47e0c34a3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "1 Civic Center Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Civic Center Plaza, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-3add-714f-81a3-1f70749d1b01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3add-714f-81a3-1f70749d1b01",
        "storage_key": "property/6767906449167040/019d270e-3add-714f-81a3-1f70749d1b01.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12352449684385399443&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "1-civic-center-plaza",
      "poi_latitude": "31.7576845",
      "poi_longitude": "-106.4917571",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVV8fxY54YRk4Ktt4q3bKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a31ad73a-2e58-4fdc-a08c-b0094a44e3ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "TransPerfect Connect",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1015 Belvidere St, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-3baf-75a8-9671-93b8c4eee2d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3baf-75a8-9671-93b8c4eee2d1",
        "storage_key": "property/6767906449167040/019d270e-3baf-75a8-9671-93b8c4eee2d1.webp",
        "width": 1280,
        "height": 740
      },
      "poi_business_url": "https://www.transperfectconnect.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17503557915821498174&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "transperfect-connect",
      "poi_latitude": "31.8540386",
      "poi_longitude": "-106.5409878",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-289-9425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGydw0WT53YYRPl8Exi8h6fI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_07f9178a-666d-43f4-a419-1dcfa079a219",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Fort Bliss Family and MWR",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Building 11, Pershing Rd, Fort Bliss, TX 79916, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://bliss.armymwr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16320776352191715737&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-family-and-mwr",
      "poi_latitude": "31.8066444",
      "poi_longitude": "-106.4355472",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 915-568-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-448f-750e-a9f2-22a733b42dc9",
        "storage_key": "property/6767906449167040/019d270e-448f-750e-a9f2-22a733b42dc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr7qMsRxa54YRmZn7Ap8Lf-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cee8d0c1-fead-404d-aeab-2756107d3a20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Western Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "530 Thunderbird Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://westernhills.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16557716768082756121&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "western-hills-elementary-school",
      "poi_latitude": "31.8414541",
      "poi_longitude": "-106.5227464",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-236-3850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ece7-701d-a264-783091f950a1",
        "storage_key": "property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeTGw1s9X54YRGQIajazTyOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d8de92d2-4d85-4bd0-a00d-8fd449cf1ac0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Dr. Green Elementary School",
      "poi_type": "Education",
      "poi_address": "5430 Buckley Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-2a9f-74e7-8583-0786220c7529.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2a9f-74e7-8583-0786220c7529",
        "storage_key": "property/6767906449167040/019d7917-2a9f-74e7-8583-0786220c7529.webp",
        "width": 1280,
        "height": 507
      },
      "poi_business_url": "https://www.episd.org/o/gres",
      "poi_directions_map_url": "https://maps.google.com/?cid=17283601174716929722&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dr-green-elementary-school",
      "poi_latitude": "31.822663",
      "poi_longitude": "-106.511893",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-236-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ece7-701d-a264-783091f950a1",
        "storage_key": "property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF_WoxuxX54YRutaGKrKv2-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f6068206-9a69-48ab-a58c-02ffe12b65b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "IDEA Mesa Hills",
      "poi_type": "Education",
      "poi_address": "405 Wallenberg Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-2deb-730d-9ef6-169be34968e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2deb-730d-9ef6-169be34968e2",
        "storage_key": "property/6767906449167040/019d7917-2deb-730d-9ef6-169be34968e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ideapublicschools.org/our-schools/idea-mesa-hills",
      "poi_directions_map_url": "https://maps.google.com/?cid=1490109675309608863&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "idea-mesa-hills",
      "poi_latitude": "31.8170045",
      "poi_longitude": "-106.524297",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-888-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ece7-701d-a264-783091f950a1",
        "storage_key": "property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu5Y_MNJX54YRn68z0drurRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_76618571-c3dd-405b-be64-339f9cd61f08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Coronado High School",
      "poi_type": "Education",
      "poi_address": "100 Champions Pl, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-31da-75a8-99ba-89e5a2b9a1b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-31da-75a8-99ba-89e5a2b9a1b2",
        "storage_key": "property/6767906449167040/019d7917-31da-75a8-99ba-89e5a2b9a1b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://coronado.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14130504508255682606&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "coronado-high-school",
      "poi_latitude": "31.8370723",
      "poi_longitude": "-106.5467083",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-236-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ece7-701d-a264-783091f950a1",
        "storage_key": "property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCSIuemX43YYRLsCiz_uiGcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0b2be9b1-4a2c-406c-b507-9d9e625ec797",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Premier High School - El Paso (Mesa)",
      "poi_type": "Education",
      "poi_address": "1035 Belvidere St #116, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-2d5f-7634-adf7-be0d5a98053b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2d5f-7634-adf7-be0d5a98053b",
        "storage_key": "property/6767906449167040/019d7917-2d5f-7634-adf7-be0d5a98053b.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://premierhighschools.com/el-paso-mesa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3096555490899909456&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "premier-high-school-el-paso-mesa",
      "poi_latitude": "31.85390809999999",
      "poi_longitude": "-106.540461",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-581-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ece7-701d-a264-783091f950a1",
        "storage_key": "property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJazJXWoH43YYRUNtfDtAs-So",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_86138b7b-25cc-46d7-aacf-e567227b255b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "The University of Texas at El Paso",
      "poi_type": "Education",
      "poi_address": "3333 N Mesa St, El Paso, TX 79902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.utep.edu/chs/pt/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15385263784180211019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-texas-at-el-paso",
      "poi_latitude": "31.7831287",
      "poi_longitude": "-106.5067634",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-747-8207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ece7-701d-a264-783091f950a1",
        "storage_key": "property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzfwroGBZ54YRS12-p-Vvg9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9acc7710-d87c-4cbc-a89d-c40944bf87d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Doña Ana Community College - Sunland Park Center",
      "poi_type": "Education",
      "poi_address": "3365 McNutt Rd, Sunland Park, NM 88063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-3585-73c8-a3a3-98ce9c5a4a97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3585-73c8-a3a3-98ce9c5a4a97",
        "storage_key": "property/6767906449167040/019d7917-3585-73c8-a3a3-98ce9c5a4a97.webp",
        "width": 1280,
        "height": 793
      },
      "poi_business_url": "https://catalogs.nmsu.edu/dona-ana/general-information/dacc-locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3668339593917153312&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "do-a-ana-community-college-sunland-park-center",
      "poi_latitude": "31.8082866",
      "poi_longitude": "-106.5916976",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 575-874-7780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ece7-701d-a264-783091f950a1",
        "storage_key": "property/6767906449167040/019cfb51-ece7-701d-a264-783091f950a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlVm9sM_53YYRIMDuymyP6DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f3ffe4c0-aaf2-4316-ab46-88eb821b9c86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Village Inn",
      "poi_type": "Restaurants",
      "poi_address": "6040 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Family-friendly chain serving homestyle American classics such as chicken-fried steak & pot pie.",
      "poi_long_description": "People say this breakfast restaurant serves delicious food. They also highlight the excellent service and friendly atmosphere.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-361d-7674-8b24-d411dd467cb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-361d-7674-8b24-d411dd467cb0",
        "storage_key": "property/6767906449167040/019d7917-361d-7674-8b24-d411dd467cb0.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.villageinn.com/el-paso-tx-balboa",
      "poi_directions_map_url": "https://maps.google.com/?cid=148914590045192203&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "village-inn",
      "poi_latitude": "31.830982",
      "poi_longitude": "-106.5303053",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-581-6329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ecf5-70ca-b474-7bf4445a4f3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ecf5-70ca-b474-7bf4445a4f3f",
        "storage_key": "property/6767906449167040/019cfb51-ecf5-70ca-b474-7bf4445a4f3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1QqXOdX54YRC0CE2QcNEQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_b20158db-0ebe-4842-a489-014c9e2aada5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Avila's Mexican Food",
      "poi_type": "Restaurants",
      "poi_address": "6232 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Family-run stalwart serving enchiladas & other Mexican faves in a lively space with large booths.",
      "poi_long_description": "People say this Mexican restaurant serves delicious chicken fajitas, enchiladas, and gorditas. They also highlight the friendly and attentive service, and the fresh chips and salsa.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-3820-729a-a990-3fdde51fa901.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3820-729a-a990-3fdde51fa901",
        "storage_key": "property/6767906449167040/019d7917-3820-729a-a990-3fdde51fa901.webp",
        "width": 1280,
        "height": 1198
      },
      "poi_business_url": "https://avilaselpasotx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18345731577327701139&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "avila-s-mexican-food",
      "poi_latitude": "31.8321954",
      "poi_longitude": "-106.5326194",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-584-3621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ecf5-70ca-b474-7bf4445a4f3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ecf5-70ca-b474-7bf4445a4f3f",
        "storage_key": "property/6767906449167040/019cfb51-ecf5-70ca-b474-7bf4445a4f3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-bjhL99X54YRk8xIc6shmf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ef0b7e9a-96ca-44af-9c28-52b3cc892320",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Koze Teppan Grill",
      "poi_type": "Restaurants",
      "poi_address": "6127 N Mesa St B, El Paso, TX 79912, USA",
      "poi_short_description": "Chefs grill meats & veggies tableside at this lively Japanese spot also offering sushi & cocktails.",
      "poi_long_description": "Diners say this bar and grill offers great portion sizes and delicious food, including the Bento box and New York steak with shrimp. They also highlight the reasonable prices, especially compared to other local establishments.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-438e-74de-81bf-3eea2f26ade2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-438e-74de-81bf-3eea2f26ade2",
        "storage_key": "property/6767906449167040/019d7917-438e-74de-81bf-3eea2f26ade2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kozeteppangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5815450502152114703&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "koze-teppan-grill",
      "poi_latitude": "31.8308127",
      "poi_longitude": "-106.5322486",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-584-1128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-7493-741d-98ee-11446e065cef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7917-7493-741d-98ee-11446e065cef",
        "storage_key": "property/6767906449167040/019d7917-7493-741d-98ee-11446e065cef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_5VHt9X54YRD9KkjWuhtFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_3f574f21-552f-480f-a11d-419570dcf856",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "TIPPI TEAS",
      "poi_type": "Restaurants",
      "poi_address": "255 Shadow Mountain Dr E, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this health food store offers a wide selection of loose leaf teas, smoothies, and breakfast bowls. They highlight the healthy and tasty options, and the convenient location. They also like the friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-4974-7543-af8a-599f8f1312e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4974-7543-af8a-599f8f1312e3",
        "storage_key": "property/6767906449167040/019d7917-4974-7543-af8a-599f8f1312e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tippiteas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6426111957207658669&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tippi-teas",
      "poi_latitude": "31.8326991",
      "poi_longitude": "-106.5265984",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-239-4166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ecf5-70ca-b474-7670b928fc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ecf5-70ca-b474-7670b928fc7a",
        "storage_key": "property/6767906449167040/019cfb51-ecf5-70ca-b474-7670b928fc7a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOxTgl-lX54YRrbBAMMciLlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health_food_store"
    },
    {
      "id": "custom_e899bf96-bee3-42f4-aaa1-ebf4c882b19f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Tropical Smoothie Cafe",
      "poi_type": "Restaurants",
      "poi_address": "5905 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_long_description": "People say this juice shop offers delicious smoothies and bowls. They also highlight the helpful staff and the wide variety of add-ins.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-488b-7778-b74f-097991ca310e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-488b-7778-b74f-097991ca310e",
        "storage_key": "property/6767906449167040/019d7917-488b-7778-b74f-097991ca310e.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://locations.tropicalsmoothiecafe.com/tx/el-paso/5905-n.-mesa-street?y_source=1_MTA5MDQyMjQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=411558696235432224&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tropical-smoothie-cafe",
      "poi_latitude": "31.828869",
      "poi_longitude": "-106.528629",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-271-8035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ecf5-70ca-b474-7bf4445a4f3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ecf5-70ca-b474-7bf4445a4f3f",
        "storage_key": "property/6767906449167040/019cfb51-ecf5-70ca-b474-7bf4445a4f3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8W6d4d1X54YRIPlVJXQmtgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "custom_faf6bb23-d649-49cd-8ffd-7f5ede9c0852",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Mesa Street Antique Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "6545 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Store for antiques such as furniture, jewelry, and clothing, plus estate sale services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-4a4c-7323-99bb-9f9c81e1054f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4a4c-7323-99bb-9f9c81e1054f",
        "storage_key": "property/6767906449167040/019d7917-4a4c-7323-99bb-9f9c81e1054f.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://mesastreetantiquemall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10940532016950213492&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mesa-street-antique-mall",
      "poi_latitude": "31.8330274",
      "poi_longitude": "-106.5392098",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-584-0868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ecf5-70ca-b474-7670b928fc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ecf5-70ca-b474-7670b928fc7a",
        "storage_key": "property/6767906449167040/019cfb51-ecf5-70ca-b474-7670b928fc7a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWcvDlHb43YYRdPsabOeT1Jc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_6c425601-09bd-48e2-9499-49709aabf17c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "The Outlet Shoppes at El Paso",
      "poi_type": "Shopping & Retail",
      "poi_address": "7051 S Desert Blvd, Canutillo, TX 79835, USA",
      "poi_short_description": "Colorful, contemporary outlet mall with a kids’ playground & splash pad & a food court.",
      "poi_long_description": "People say this outlet mall offers a wide variety of brand-name stores with good deals and discounts. They highlight the abundant parking, clean facilities, and average food court with a bar. They also like the well-maintained property and convenient location.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-5614-77e9-87a8-3a0ca2ed1b59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5614-77e9-87a8-3a0ca2ed1b59",
        "storage_key": "property/6767906449167040/019d7917-5614-77e9-87a8-3a0ca2ed1b59.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.theoutletshoppesatelpaso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7804044863194317612&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-outlet-shoppes-at-el-paso",
      "poi_latitude": "31.9122222",
      "poi_longitude": "-106.5855556",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-877-3208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ecf5-70ca-b474-7670b928fc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ecf5-70ca-b474-7670b928fc7a",
        "storage_key": "property/6767906449167040/019cfb51-ecf5-70ca-b474-7670b928fc7a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTVOQPeH-3YYRLMPomXSJTWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_53868436-5e95-46fa-b347-fa4237adb433",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "6020 N Mesa St Suite A, El Paso, TX 79912, USA",
      "poi_short_description": "Department store chain selling discounted clothing for men, women, juniors, and plus sizes, plus home goods and shoes.",
      "poi_long_description": "People say this clothing store offers a wide selection of apparel and other items. They also highlight the affordable prices and bargains.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-52aa-76bd-92d9-d43e8033acc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-52aa-76bd-92d9-d43e8033acc5",
        "storage_key": "property/6767906449167040/019d7917-52aa-76bd-92d9-d43e8033acc5.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/tx/el-paso/345/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5422171306617465448&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "31.8322442",
      "poi_longitude": "-106.5283936",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-833-6348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ecf5-70ca-b474-7670b928fc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ecf5-70ca-b474-7670b928fc7a",
        "storage_key": "property/6767906449167040/019cfb51-ecf5-70ca-b474-7670b928fc7a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOT6QINxX54YRaOo_UhNsP0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_ec1e9a9a-4c5a-420d-a3b7-1af8f7c38672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Food King",
      "poi_type": "Shopping & Retail",
      "poi_address": "6021 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this grocery store offers a wide selection of Mexican produce, salsas, spices, and foods, as well as fresh vegetables and fruit. They also highlight the affordable prices, good deals on groceries, and the friendly and helpful staff.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-5996-71c8-b817-919074e503a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5996-71c8-b817-919074e503a2",
        "storage_key": "property/6767906449167040/019d7917-5996-71c8-b817-919074e503a2.webp",
        "width": 1280,
        "height": 867
      },
      "poi_business_url": "https://www.foodkingcostplus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12106946363503838783&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "food-king",
      "poi_latitude": "31.8297081",
      "poi_longitude": "-106.5307181",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-584-2070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-ecec-7508-8487-74dc9bee8103.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-ecec-7508-8487-74dc9bee8103",
        "storage_key": "property/6767906449167040/019cfb51-ecec-7508-8487-74dc9bee8103.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVgSd95X54YRP4Zaf5KDBKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_480acc55-6fbe-4067-9f92-b7c69153c50d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Bob-O's Family Fun Center",
      "poi_type": "Entertainment",
      "poi_address": "3851 Constitution Dr, El Paso, TX 79922, USA",
      "poi_short_description": "Amusement venue with laser tag, go-karts, bumper boats, batting cages, an arcade, snacks & more.",
      "poi_long_description": "People say this amusement center offers a variety of fun activities, including go-karts, bumper boats, laser tag, and arcade games. They also highlight the reasonable prices and friendly, accommodating staff.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-5a2a-754d-8df9-41ef2821f5a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5a2a-754d-8df9-41ef2821f5a4",
        "storage_key": "property/6767906449167040/019d7917-5a2a-754d-8df9-41ef2821f5a4.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://bobosfun.com/?utm_source=gmb&utm_medium=organic&utm_campaign=elpaso",
      "poi_directions_map_url": "https://maps.google.com/?cid=18166085088815833051&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bob-o-s-family-fun-center",
      "poi_latitude": "31.8126125",
      "poi_longitude": "-106.5540313",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-587-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-eceb-735b-8c57-d3c012a453f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-eceb-735b-8c57-d3c012a453f4",
        "storage_key": "property/6767906449167040/019cfb51-eceb-735b-8c57-d3c012a453f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-acwxn43YYR219j5iPmGvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_26efc396-18ad-4227-afc3-e28871b5bceb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Keystone Heritage Park and the El Paso Desert Botanical Garden",
      "poi_type": "Entertainment",
      "poi_address": "4200 Doniphan Dr, El Paso, TX 79922, USA",
      "poi_short_description": "This 52-acre park features botanical gardens, wetlands & the remains of an ancient village.",
      "poi_long_description": "People say this botanical garden offers beautiful, tranquil, and well-maintained nature trails, a thriving pond filled with bird life, and a maze. They highlight the peaceful and relaxing atmosphere, and the opportunity to learn about the historic Rio Grande Del Norte and the local flora and fauna. They also like the affordable entry fee and the availability of shade and seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-5df1-75f9-8143-f64e432cb837.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5df1-75f9-8143-f64e432cb837",
        "storage_key": "property/6767906449167040/019d7917-5df1-75f9-8143-f64e432cb837.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.keystoneheritagepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12019324138855344271&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "keystone-heritage-park-and-the-el-paso-desert-botanical-garden",
      "poi_latitude": "31.820571",
      "poi_longitude": "-106.563529",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-490-8571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-eceb-735b-8c57-d3c012a453f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-eceb-735b-8c57-d3c012a453f4",
        "storage_key": "property/6767906449167040/019cfb51-eceb-735b-8c57-d3c012a453f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfzjy2D743YYRjyjAiJ83zaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_b7802d40-b85f-41e3-9e69-aa3807743243",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Franklin Mountains State Park",
      "poi_type": "Entertainment",
      "poi_address": "Thunderbird Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Hiking area offering shade trees, sunset views, and a grilling area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019d7917-634f-7492-a1dd-de6b1169e3a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-634f-7492-a1dd-de6b1169e3a0",
        "storage_key": "property/6767906449167040/019d7917-634f-7492-a1dd-de6b1169e3a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3261171865648773583&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "franklin-mountains-state-park",
      "poi_latitude": "31.8513961",
      "poi_longitude": "-106.5098828",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-eceb-735b-8c57-d3c012a453f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-eceb-735b-8c57-d3c012a453f4",
        "storage_key": "property/6767906449167040/019cfb51-eceb-735b-8c57-d3c012a453f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0EHk0pW54YRzzl-i4gCQi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_99cd8f1a-4a52-4952-8598-edd0e76f657e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Morehead Middle School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "morehead-middle-school",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ea3e0c5a-30b2-4a22-b839-0ea75b4fb8e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "poi_name": "Basico Bistro Cafe",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "basico-bistro-cafe",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_1e8cc29c91472e6f13899be0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6bf49cac802cf7903b432027",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_de92290d967b4d96e21a19b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c93e9eb0898236af9b0dcdd3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_23e7f42cb3bbda6aaee8d0a4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_13269210-5c29-4d10-af05-7f5e91876519",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "rating": "5.0",
      "name": "Jennifer Gonzalez",
      "text": "Been living here for almost 6 months now and all I can say these are the best apartments I’ve lived in! Super clean, attentive, comfy and they respond fast to maintence requests. Love the gym, pool and the chimney that my apartment has!! 🥰",
      "date": "2025-11-19",
      "title": ""
    },
    {
      "id": "custom_85dcda45-8d65-4e95-bc34-bad4f2d8c3c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "rating": "5.0",
      "name": "John Reynolds",
      "text": "We're an older couple, and have had an apartment at the Crest for a year. We are very pleased. The complex is quiet and well cared for, and the maintenance staff is responsive whenever we need them.",
      "date": "2025-12-02",
      "title": ""
    },
    {
      "id": "custom_ecb1b074-7a44-4a17-8e61-458683804d81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "rating": "5.0",
      "name": "Dawn Griffith",
      "text": "From the start we have had an amazing experience here at The Crest! Very well kept grounds to the pool and the dog park. If I had one thing to say is the parking is rough to get a spot at times.",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_d92713e2-1baf-4a77-ad5b-171ff70df596",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "rating": "5.0",
      "name": "Matt Beemer",
      "text": "The Crest maintenance member was quick at resolving my issue. I was pleased with the work and he was very friendly with letting me know how the problem occurred",
      "date": "2026-01-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_26cdf87a-e9c7-4a54-9bff-fd3fac2be985",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb52-a807-763d-aae3-5324bd0f480c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of the outdoor swimming pool and surrounding lounge area at an apartment complex.",
        "public_id": "019cfb52-a807-763d-aae3-5324bd0f480c",
        "storage_key": "property/6767906449167040/019cfb52-a807-763d-aae3-5324bd0f480c.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Crest Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f6d58b5ee5aba0c3b8bda12"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-b500-7664-976f-4f780ec8e2f1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-crest",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040"
    },
    {
      "lead_collector_id": "019cf79d-b570-768b-8047-2d5b8fedfa8d",
      "lead_source": "LANDING_PAGE",
      "name": "the-crest",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-el-paso-tx",
      "search_query": "pet friendly apartments in El Paso TX",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in El Paso, TX",
      "h2_subtitle": "Discover pet-friendly living at The Crest, located in Northwest El Paso. Enjoy the convenience of an onsite pet park as part of our welcoming community.",
      "page_copy": "Looking for pet friendly apartments in El Paso, TX? The Crest offers the perfect home for you and your furry friends. Located in the bustling neighborhood of Northwest El Paso, our community understands the importance of pets in your life. You'll love our onsite pet park, where your pets can run and play freely. At The Crest, we go beyond just accepting pets; we provide a supportive environment for them too.\n\nOur spacious apartments feature upgraded stainless-steel kitchen appliances, two onsite laundry facilities, and convenient flex payment options. Experience a lifestyle that comprehensively caters to both you and your pets' needs. With comfortable living spaces and access to covered parking with our carport options, The Crest makes it easy to live and thrive in a pet-friendly community in El Paso, TX. Visit us today to find your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in El Paso, TX",
      "seo_description": "Discover pet friendly apartments at The Crest in El Paso, TX. Upscale amenities and an onsite pet park perfect for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "apartments-with-pool-northwest-el-paso",
      "search_query": "apartments with a pool in Northwest El Paso ",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Northwest El Paso",
      "h2_subtitle": "Experience luxury living at The Crest, where features like a pool enhance your life. Nestled in Northwest El Paso, our community is the place to call home.",
      "page_copy": "If you're seeking apartments with a pool in Northwest El Paso, look no further than The Crest. While our community features a wide range of amenities designed to cater to your lifestyle, our pool area truly steals the spotlight. Imagine sunny days spent lounging by the pool, enjoying the serene environment that our community offers. Beyond the pool, life at The Crest comes with the perk of being located in a vibrant neighborhood full of conveniences.\n\nThe Crest not only offers a potential pool paradise but also boasts upgraded stainless-steel kitchen appliances, flexible payment options, and two onsite laundry facilities. Along with ample parking provided by our carports, residents can bring furry friends along, with an onsite pet park designed just for them. Join a community in Northwest El Paso that offers so much more than just apartments—with The Crest, enjoy a lifestyle enriched by exceptional amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Northwest El Paso",
      "seo_description": "Explore The Crest for apartments with a pool in Northwest El Paso. Enjoy luxury living with poolside relaxation and other upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-79912-el-paso",
      "search_query": "fitness center apartments 79912",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments 79912",
      "h2_subtitle": "Explore fitness-friendly living at The Crest in zip code 79912. While a fitness center isn't onsite, enjoy our variety of lifestyle amenities.",
      "page_copy": "Searching for fitness center apartments in the 79912 area? Although The Crest does not feature an onsite fitness center, our community in Northwest El Paso has a wealth of amenities designed to support a healthy lifestyle. We offer a vibrant environment where the active lifestyle is embraced, with an onsite pet park for exercise and play, alongside the convenience of local fitness centers nearby.\n\nBeyond fostering fitness, The Crest boasts modern comforts such as upgraded stainless-steel kitchen appliances, flexible payment options, and dual onsite laundry facilities. Our carports provide convenient parking, completing the ease of living offered. Nestled in the heart of the 79912 area, The Crest is surrounded by community amenities that further enhance active living, making it a sought-after location for health-conscious individuals.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments 79912 El Paso",
      "seo_description": "Find health-focused living at The Crest in 79912. While a fitness center isn't onsite, enjoy lifestyle amenities perfect for active individuals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "apartments-wood-burning-fireplaces-el-paso-county",
      "search_query": "apartments with wood-burning fireplaces El Paso County",
      "category": "Amenity",
      "h1_title": "Cozy Apartments with Wood-Burning Fireplaces",
      "h2_subtitle": "Find comfort in El Paso County at The Crest. While we don't feature wood-burning fireplaces, our amenities offer warmth and style.",
      "page_copy": "For those seeking apartments with wood-burning fireplaces in El Paso County, The Crest offers a comforting lifestyle with modern appeal. While our residences don’t come with wood-burning fireplaces, residents enjoy the warmth and elegance of our upgraded interiors, including stainless-steel kitchen appliances. Nestled in the charming area of Northwest El Paso, The Crest provides an inviting atmosphere enhanced by amenity-rich offerings.\n\nResidents appreciate conveniences such as two onsite laundry facilities and carport parking options. We also cater to pet owners with an onsite pet park that adds charm to our community living. Although not featuring a fireplace, The Crest encapsulates the coziness and community spirit desired in apartment living, paired with the beauty of its surroundings in El Paso County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Wood-Burning Fireplaces El Paso",
      "seo_description": "Experience cozy living at The Crest in El Paso County. While we don't have wood-burning fireplaces, our modern amenities provide warmth and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "basketball-court-apartments-el-paso",
      "search_query": "basketball court apartments El Paso",
      "category": "Amenity",
      "h1_title": "Apartments Near Basketball Courts El Paso",
      "h2_subtitle": "Discover active living at The Crest in El Paso. Although we lack a basketball court, our community provides a rich array of engaging amenities.",
      "page_copy": "If you're searching for basketball court apartments in El Paso, you’ll find a vibrant community environment at The Crest. While our community doesn't feature an onsite basketball court, we offer numerous amenities designed to support an active lifestyle, including proximity to local sports complexes. Located in Northwest El Paso, The Crest provides an exciting living experience with ample recreational opportunities nearby.\n\nResidents enjoy a variety of conveniences such as upgraded stainless-steel kitchen appliances, flexible payment options, and two onsite laundry facilities. Our community caters to pet owners with an onsite pet park, and carports ensure convenient parking. The Crest is enthusiastically positioned in El Paso, promising both leisure and activity, making it an excellent choice for those passionate about staying active.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Basketball Court Apartments El Paso",
      "seo_description": "Live actively at The Crest in El Paso. Though there is no basketball court onsite, enjoy nearby sports facilities and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-el-paso-tx",
      "search_query": "one bedroom apartments el paso tx",
      "category": "Floorplan",
      "h1_title": "Spacious One Bedroom Apartments in El Paso",
      "h2_subtitle": "Experience comfortable living at The Crest, offering modern one-bedroom apartments in El Paso, TX, with a host of attractive amenities.",
      "page_copy": "For those seeking one-bedroom apartments in El Paso, TX, The Crest provides an ideal living solution. Our community offers contemporary one-bedroom layouts designed with comfort and functionality in mind. Nestled in the vibrant area of Northwest El Paso, The Crest is more than just a place to live—it's a lifestyle.\n\nResidents benefit from a suite of modern amenities, such as upgraded stainless-steel kitchen appliances and flexible payment options. We feature two convenient onsite laundry facilities, and our pet-friendly atmosphere is enhanced by an onsite pet park, perfect for four-legged companions. Additionally, carports add ease to your daily routine. Discover the charm of one-bedroom living at The Crest, where community and convenience unite.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments El Paso, TX",
      "seo_description": "Find your perfect one-bedroom apartment at The Crest in El Paso, TX. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "two-bedroom-floorplans-northwest-el-paso",
      "search_query": "two bedroom floorplans in northwest el paso",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floorplans in Northwest El Paso",
      "h2_subtitle": "Explore spacious living at The Crest with thoughtfully designed two-bedroom floorplans in the heart of Northwest El Paso.",
      "page_copy": "Discover the perfect home with our two-bedroom floorplans in Northwest El Paso at The Crest. Our layouts are crafted to provide ample space and modern conveniences, ideal for families, roommates, or those needing extra room. Situated in the lively Northwest El Paso, The Crest is where comfort meets convenience.\n\nEach apartment features contemporary finishes, including upgraded stainless-steel kitchen appliances. Residents can enjoy our flexible payment options and the convenience of two onsite laundry facilities. Pet lovers will appreciate the onsite pet park, creating a perfect environment for both two-legged and four-legged residents. With carport availability, parking is hassle-free. Experience the best of two-bedroom living at The Crest, perfectly positioned in a dynamic neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floorplans in Northwest El Paso",
      "seo_description": "Find spacious two-bedroom floorplans at The Crest in Northwest El Paso. Experience modern living with generous amenities and vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-79912",
      "search_query": "three bedroom apartments near 79912",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 79912",
      "h2_subtitle": "Find expansive three-bedroom apartments near the 79912 area at The Crest. Enjoy a blend of comfort and convenience in El Paso.",
      "page_copy": "If you're searching for three-bedroom apartments near the 79912 zip code, The Crest offers a perfect solution. Our spacious three-bedroom units are designed with both style and functionality in mind, ideal for larger households or those wanting extra space. Located in the dynamic Northwest El Paso, The Crest combines a prime location with an array of modern amenities.\n\nResidents enjoy living in a community featuring upgraded stainless-steel kitchen appliances, flexible payment options, and access to two onsite laundry facilities. Our pet-friendly atmosphere is complemented by an onsite pet park, while carports are available to ensure easy parking. Experience the best in three-bedroom living at The Crest, where practicality meets a vibrant community lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 79912",
      "seo_description": "Discover three-bedroom apartments at The Crest near the 79912 area. Enjoy spacious living and modern amenities in a prime El Paso location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-texas-el-paso",
      "search_query": "apartments near University of Texas El Paso",
      "category": "School",
      "h1_title": "Apartments Near University of Texas El Paso",
      "h2_subtitle": "Discover The Crest, offering convenient apartments near the University of Texas El Paso. Perfect for students and professionals alike.",
      "page_copy": "The Crest provides ideal living solutions with our apartments near the University of Texas El Paso. Situated in the vibrant Northwest El Paso area, our community is just a short drive from campus, making it an ideal choice for students, faculty, and staff seeking proximity and convenience.\n\nOur apartments boast modern amenities such as upgraded stainless-steel kitchen appliances and flexible payment options, catering to diverse needs. With two onsite laundry facilities, residents never have to worry about laundry day logistics. Our pet-friendly environment includes an onsite pet park, adding comfort for pet owners. Additionally, carports are available for hassle-free parking. Experience the convenience and community spirit at The Crest, where El Paso's charm meets modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Texas El Paso",
      "seo_description": "Find modern apartments at The Crest, conveniently located near the University of Texas El Paso. Ideal for students and staff seeking a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "epcc-rio-grande-campus-apartments-nw-el-paso",
      "search_query": "El Paso Community College Rio Grande Campus apartments in Northwest El Paso",
      "category": "School",
      "h1_title": "Apartments Near EPCC Rio Grande Campus",
      "h2_subtitle": "Discover The Crest, featuring apartments conveniently located near El Paso Community College Rio Grande Campus in Northwest El Paso.",
      "page_copy": "The Crest offers prime living spaces with our apartments near El Paso Community College Rio Grande Campus, bringing both comfort and convenience to busy students and professionals. Located in vibrant Northwest El Paso, our community makes commuting stress-free, allowing residents more time for studies and leisure.\n\nOur apartments come equipped with modern features such as upgraded stainless-steel kitchen appliances, facilitating an ideal home environment. Flexible payment options and two onsite laundry facilities enhance everyday convenience. We also offer a pet-friendly atmosphere complete with an onsite pet park, ensuring a warm welcome for all residents, furry friends included. With available carports, parking is simple and stress-free. Come explore life at The Crest, where modern amenities meet a vibrant community vibe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near EPCC Rio Grande Campus",
      "seo_description": "Live at The Crest, with modern apartments near El Paso Community College Rio Grande Campus in NW El Paso. Ideal for students and staff alike.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "apartments-near-las-palmas-medical-center",
      "search_query": "apartments near Las Palmas Medical Center El Paso",
      "category": "Hospital",
      "h1_title": "Apartments Near Las Palmas Medical Center",
      "h2_subtitle": "Explore The Crest’s comfortable apartments near Las Palmas Medical Center El Paso, designed for convenience and modern living.",
      "page_copy": "If proximity to healthcare and comfort are your priorities, The Crest offers the perfect solution with our apartments near Las Palmas Medical Center in El Paso. Situated in Northwest El Paso, our community provides the convenience of quick access to healthcare facilities, making it ideal for medical professionals and families.\n\nOur apartments feature upgraded stainless-steel kitchen appliances, bringing a touch of elegance and efficiency to everyday living. Residents appreciate the flexible payment options and the practicality of two onsite laundry facilities. Pet lovers will find The Crest welcoming, with an onsite pet park ensuring furry companions have their own recreational space. The availability of carports adds an extra layer of convenience, ensuring peace of mind for all residents. Experience the blend of modern amenities and a welcoming community at The Crest.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Las Palmas Medical Center El Paso",
      "seo_description": "Find modern apartments at The Crest, conveniently near Las Palmas Medical Center. Ideal for healthcare professionals seeking comfort in El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "apartments-near-hospitals-of-providence-sierra-campus",
      "search_query": "apartments close to The Hospitals of Providence Sierra Campus Northwest El Paso",
      "category": "Hospital",
      "h1_title": "Apartments Near Providence Sierra Campus",
      "h2_subtitle": "Discover The Crest's inviting apartments close to The Hospitals of Providence Sierra Campus in Northwest El Paso, perfect for healthcare professionals.",
      "page_copy": "The Crest is the ideal choice if you're seeking apartments close to The Hospitals of Providence Sierra Campus in Northwest El Paso. Our location offers a convenient base for healthcare workers, enabling quick commutes, maximizing your home and work-life balance.\n\nDesigned for modern living, our apartments include upgraded stainless-steel kitchen appliances and flexible payment options, ensuring comfort and adaptability. The community features two onsite laundry facilities, enhancing day-to-day convenience. Pet owners will appreciate the onsite pet park, catering to all members of the family. With available carports, parking is hassle-free, providing an effortless lifestyle experience at The Crest. Join our welcoming community and enjoy the synergy of comfort and location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Providence Sierra Campus El Paso",
      "seo_description": "Find comfortable apartments at The Crest, conveniently located near The Hospitals of Providence Sierra Campus in Northwest El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "apartments-near-franklin-mountains-state-park",
      "search_query": "apartments near Franklin Mountains State Park El Paso",
      "category": "Park",
      "h1_title": "Apartments Near Franklin Mountains State Park",
      "h2_subtitle": "Experience The Crest’s unique apartments near Franklin Mountains State Park in El Paso, offering nature lovers convenient access to outdoor adventures.",
      "page_copy": "For those who treasure nature and adventure, The Crest offers exceptional apartments near Franklin Mountains State Park in El Paso. Our location in Northwest El Paso allows easy access to one of the largest urban wilderness parks in the country, perfect for hiking, cycling, and outdoor exploration.\n\nThe Crest community provides modern living with upgraded stainless-steel kitchen appliances and flexible payment options to suit various lifestyles. Two onsite laundry facilities add convenience, while our onsite pet park welcomes residents with pets. Covered parking is available in our carport, ensuring your vehicle is protected. Enjoy the blend of modern amenities and prime location close to nature at The Crest.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Franklin Mountains State Park El Paso",
      "seo_description": "Live close to adventure at The Crest, offering modern apartments near Franklin Mountains State Park in Northwest El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "apartments-near-memorial-park-northwest-el-paso",
      "search_query": "apartments close to Memorial Park Northwest El Paso",
      "category": "Park",
      "h1_title": "Apartments Near Memorial Park El Paso",
      "h2_subtitle": "Live at The Crest, with stylish apartments close to Memorial Park in Northwest El Paso, perfect for park lovers and outdoor enthusiasts.",
      "page_copy": "Nestled in the heart of Northwest El Paso, The Crest offers stylish apartments close to Memorial Park, making it ideal for those who appreciate the beauty and recreational opportunities of nearby green spaces. Whether you're a fan of walking, picnicking, or simply enjoying nature, The Crest provides the perfect living environment.\n\nOur community features upgraded stainless-steel kitchen appliances for a modern touch, and flexible payment options make it easy to find a plan that suits you. Enjoy the convenience of two onsite laundry facilities and a carport for protected parking. Our onsite pet park ensures that even furry family members feel at home. Discover the blend of comfort and accessibility at The Crest, where the great outdoors is just steps away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Park Northwest El Paso",
      "seo_description": "Enjoy modern living at The Crest, featuring apartments conveniently close to Memorial Park in Northwest El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "apartments-near-braden-aboud-memorial-park-el-paso",
      "search_query": "Braden Aboud Memorial Park nearby apartments",
      "category": "Park",
      "h1_title": "Apartments Near Braden Aboud Memorial Park",
      "h2_subtitle": "Discover comfortable living at The Crest, with nearby apartments close to Braden Aboud Memorial Park, a perfect spot in Northwest El Paso.",
      "page_copy": "If you are searching for Braden Aboud Memorial Park nearby apartments, look no further than The Crest in Northwest El Paso. Our community offers an exceptional living experience just minutes from the park, which is a local favorite for its walking trails, recreational facilities, and vibrant community events.\n\nAt The Crest, residents enjoy amenities designed to enhance their lifestyle, such as upgraded stainless-steel kitchen appliances and flexible payment options. We offer two onsite laundry facilities for your convenience and carports for secure parking. Plus, our pet-friendly environment features an onsite pet park, making it a welcoming place for all family members. Embrace the convenience and beauty of living near Braden Aboud Memorial Park at The Crest.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Braden Aboud Memorial Park Nearby Apartments",
      "seo_description": "The Crest offers beautiful apartments near Braden Aboud Memorial Park, providing a prime location in Northwest El Paso. Enjoy modern amenities and nearby green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "apartments-near-madeline-park-79912",
      "search_query": "apartments by Madeline Park 79912",
      "category": "Park",
      "h1_title": "Apartments by Madeline Park in 79912",
      "h2_subtitle": "Explore The Crest’s charming apartments by Madeline Park in the 79912 area, offering a harmonious blend of community and convenience.",
      "page_copy": "The Crest presents exceptional apartments by Madeline Park in the 79912 area, a perfect choice for those seeking leisure and comfort in Northwest El Paso. Madeline Park, known for its relaxing green spaces and community-friendly environment, is just a stone’s throw away, providing an ideal setting for those who love spending time outdoors.\n\nOur apartments feature upgraded stainless-steel kitchen appliances and flexible payment options that cater to diverse needs. Residents benefit from two onsite laundry facilities and covered parking in our carport, ensuring convenience and ease of living. Additionally, our onsite pet park ensures a pet-friendly atmosphere for animal lovers. Enjoy the modern amenities and prime location near Madeline Park at The Crest, where city living meets natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Madeline Park 79912",
      "seo_description": "Live at The Crest and experience the convenience of apartments by Madeline Park in the 79912 area of Northwest El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167040",
      "source": "generator",
      "page_item_url": "apartments-near-tom-lea-upper-park-el-paso-county",
      "search_query": "Tom Lea Upper Park El Paso County apartments",
      "category": "Park",
      "h1_title": "Apartments Near Tom Lea Upper Park El Paso",
      "h2_subtitle": "Discover stylish living at The Crest with apartments near Tom Lea Upper Park, nestled in the scenic surroundings of El Paso County.",
      "page_copy": "For those seeking Tom Lea Upper Park El Paso County apartments, The Crest offers an optimal choice located in the picturesque surroundings of Northwest El Paso. Just a short drive from the park, our apartments provide residents with easy access to one of the area's top outdoor destinations, perfect for daily walks, exercise, and family outings.\n\nThe Crest residents enjoy upgraded stainless-steel kitchen appliances, ensuring a modern and stylish living experience. Our community supports flexible payment options and provides two onsite laundry facilities for added convenience. With a carport available for secure parking and a pet park onsite, The Crest accommodates all your lifestyle needs. Enjoy comfort and nature with our exceptional apartments near Tom Lea Upper Park in El Paso County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
      "featured_image_media": {
        "alt_text": "The Crest Apartments monument sign with landscaping and a red Case & Associates cube.",
        "public_id": "019cfb51-3652-7639-80bc-355f5fb91635",
        "storage_key": "property/6767906449167040/019cfb51-3652-7639-80bc-355f5fb91635.webp",
        "width": 2700,
        "height": 1800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tom Lea Upper Park",
      "seo_description": "The Crest offers modern apartments near Tom Lea Upper Park in El Paso County, featuring great amenities and a beautiful natural setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5168"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-272R0R2YEC"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151444"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-crest-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-529VN9MM"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167040/019d1bda-48a1-774c-a5b2-01d7a428103e.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "34370075733"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "877-284-2016"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6480cd60ac6f48a761816f51"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InFwMDU3R3VMWkF4UGF2VlMxVDFoOHc9PSIsInZhbHVlIjoiazVYcXhkUVRIUEFsTUtWcEpEeGxkQT09IiwibWFjIjoiNWRkZWE1OTY0YTI2NmU2ZWJlNDllY2Y2ZmVhMjljMDhjNzNiYjZjNmE0YmUwY2M2MDQxYTI2N2FhYzkwMTM4YSJ9"
    }
  ],
  "custom_qb_id": "5168",
  "custom_ga4_id": "G-272R0R2YEC",
  "custom_repli_id": "10041151444",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-crest-apartments/register/",
  "custom_google_gtm_id": "GTM-529VN9MM",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167040/019d1bda-48a1-774c-a5b2-01d7a428103e.pdf",
  "custom_hubspot_company_id": "34370075733",
  "custom_ppc_tracking_phone_number": "877-284-2016",
  "custom_residentboost_apartment_id": "6480cd60ac6f48a761816f51",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InFwMDU3R3VMWkF4UGF2VlMxVDFoOHc9PSIsInZhbHVlIjoiazVYcXhkUVRIUEFsTUtWcEpEeGxkQT09IiwibWFjIjoiNWRkZWE1OTY0YTI2NmU2ZWJlNDllY2Y2ZmVhMjljMDhjNzNiYjZjNmE0YmUwY2M2MDQxYTI2N2FhYzkwMTM4YSJ9"
};

export const generatedAt = '2026-08-27T21:33:07.551Z';
